{
  "app": {
    "notFound": {
      "title": "Ez nem található",
      "body": "Lehet, hogy eltávolították, vagy a hivatkozás elavult.",
      "backTo": "Vissza: {list}"
    },
    "name": "Taler",
    "foundation": "Alapok",
    "foundationBody": "A munkaterület, a határok, a szerződéses kliens, a domain primitívek, a tokenek és a mock szerver készen állnak. A termékképernyők erre épülnek.",
    "signedInAs": "Bejelentkezve mint",
    "ledgers": "Főkönyvek",
    "activeLedger": "Aktív főkönyv",
    "loading": "Betöltés",
    "role": "Szerepkör",
    "archived": "Archivált",
    "searchLedgers": "Főkönyvek keresése",
    "noLedgersFound": "Nincs találat"
  },
  "auth": {
    "notProvisionedTitle": "A fiókod nincs beállítva a Talerben",
    "notProvisionedBody": "A bejelentkezés sikerült, de ehhez a telepítéshez nem tartozik fiókod. Kérj hozzáférést egy adminisztrátortól.",
    "signInTitle": "Bejelentkezés a Talerbe",
    "signInBody": "A Taler a Google-fiókodat használja. Átirányítunk a Google-hoz, majd vissza ide.",
    "signInAction": "Folytatás Google-fiókkal",
    "devSignInAction": "Bejelentkezés mint {email} (csak fejlesztéshez)",
    "signInDeclined": "A bejelentkezés megszakadt. Semmi nem változott.",
    "callbackTitle": "Bejelentkeztetés folyamatban",
    "callbackFailedTitle": "A bejelentkezést nem sikerült befejezni",
    "callbackFailedBody": "A bejelentkezés nem fejeződött be. Kezdd újra a bejelentkezési oldalról.",
    "signOut": "Kijelentkezés"
  },
  "shell": {
    "primaryNav": "Fő navigáció",
    "noNavigation": "A szerepkörödhöz ebben a főkönyvben nincs elérhető szakasz.",
    "navGroupInsight": "Elemzés",
    "navGroupShared": "Közös főkönyvek",
    "dismissNotification": "Értesítés bezárása",
    "skipToContent": "Ugrás a tartalomra",
    "offline": "Nincs internetkapcsolat. Az utoljára betöltött adatokat mutatjuk; a módosítások csak újracsatlakozás után menthetők.",
    "version": "Verzió",
    "collapseSidebar": "Oldalsáv összecsukása",
    "expandSidebar": "Oldalsáv kibontása",
    "noLedger": "Nincs kiválasztott főkönyv",
    "language": "Nyelv",
    "account": "Fiók",
    "createLedger": {
      "action": "Főkönyv létrehozása",
      "title": "Főkönyv létrehozása",
      "description": "A főkönyv önálló könyvelés, például egy háztartásé vagy egy cégé. Te leszel a tulajdonosa.",
      "name": "Főkönyv neve",
      "template": "Kiindulás",
      "templates": {
        "PERSONAL": "Személyes számlák",
        "COMPANY": "Céges számlák",
        "SHARED": "Közös háztartási számlák"
      },
      "submit": "Főkönyv létrehozása",
      "cancel": "Mégse",
      "error": "A főkönyvet nem sikerült létrehozni. Próbáld újra."
    },
    "accountingView": "Részletes könyvelési nézet",
    "accountingViewHint": "Tartozik/követel oldal és nyers számlakódok megjelenítése",
    "displayCurrency": "Megjelenítési pénznem",
    "searchCurrencies": "Pénznemek keresése",
    "noCurrenciesFound": "Nincs találat"
  },
  "transactions": {
    "title": "Tranzakciók",
    "loading": "Tranzakciók betöltése",
    "loadMore": "Továbbiak betöltése",
    "loadingMore": "Betöltés",
    "endOfList": "Elérted a főkönyv elejét.",
    "emptyTitle": "Még nincs tranzakció",
    "emptyBody": "Rögzítsd az első tranzakciót, hogy elinduljon a főkönyv előzménye.",
    "emptyFilteredTitle": "Nincs a szűrőknek megfelelő tranzakció",
    "emptyFilteredBody": "Próbáld szélesíteni az időszakot, vagy törölj egy szűrőt.",
    "errorTitle": "A tranzakciókat nem sikerült betölteni",
    "errorBody": "Hiba történt a főkönyv olvasása közben. Próbáld újra.",
    "retry": "Újra",
    "reversed": "Sztornózva",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "noAccess": "Nincs jogosultságod ennek a főkönyvnek a tranzakcióihoz.",
    "date": "Dátum",
    "description": "Leírás",
    "expense": "Kiadás",
    "income": "Bevétel",
    "transfer": "Átutalás",
    "noKind": "Nincs típus",
    "noDescription": "Nincs leírás",
    "transferTo": "ide",
    "source": {
      "MANUAL": "kézzel rögzítve",
      "IMPORT": "import",
      "RECEIPT": "nyugta",
      "CHECKUP": "ellenőrzés",
      "SYSTEM": "rendszer",
      "SCHEDULED": "ütemezett",
      "TRANSFER": "átutalás",
      "ACCOUNT_CLOSE": "számla zárása",
      "LOAN": "kölcsön",
      "FX_REVALUATION": "árfolyam-átértékelés",
      "CROSS_LEDGER_FORGIVE": "főkönyvek közti tartozás elengedve",
      "CONTACT_FORGIVE": "kapcsolat követelés elengedve"
    },
    "filters": {
      "search": "Keresés",
      "searchPlaceholder": "Partner, megjegyzés, jegyzet keresése...",
      "from": "Kezdő dátum",
      "until": "Záró dátum",
      "account": "Számla",
      "allAccounts": "Minden számla",
      "searchAccounts": "Számlák keresése",
      "noAccountsFound": "Nincs találat",
      "merchant": "Partner",
      "tags": "Címkék",
      "allTags": "Minden címke",
      "searchTags": "Címkék keresése",
      "noTagsFound": "Nincs találat",
      "tagsHint": "Címkék (bármelyik egyezik)",
      "tagsSeparator": " vagy ",
      "kind": "Típus",
      "source": "Forrás",
      "allSources": "Minden forrás",
      "minAmount": "Min. összeg",
      "maxAmount": "Max. összeg",
      "reset": "Szűrők törlése",
      "removeFilter": "{label} szűrő eltávolítása",
      "region": "Tranzakciók szűrése",
      "anyKind": "Mind",
      "date": "Dátum",
      "amount": "Összeg",
      "moreFilters": "További szűrők"
    },
    "tableRegion": "Tranzakciók táblázata, görgethető",
    "moreActions": "További műveletek",
    "splitExpense": "Számla felosztása",
    "scanReceipt": "Blokk beolvasás",
    "importCsv": "CSV importálás",
    "groupByDay": "Csoportosítás nap szerint",
    "groupByDayHint": "Egy fejléc naponként, a nap részösszegeivel",
    "groupEntryCountOne": "1 tétel",
    "groupEntryCount": "{count} tétel",
    "groupEntryCountPartial": "{count}+ tétel",
    "groupSubtotalsPending": "A részösszegek a nap többi tételének betöltése után lesznek elérhetők",
    "noRateForDate": "Nincs árfolyam erre a napra",
    "transferSubtotalHint": "Az aznapi átutalások összege - nagyság, nem előjeles nettó",
    "crossLedgerTransfer": "Könyv közötti átutalás",
    "rateToBase": "árfolyam a könyv alapdevizájára {rate}",
    "crossLedgerLink": {
      "to": "Ide: {ledger}",
      "from": "Innen: {ledger}"
    },
    "detail": {
      "label": "Tétel részletei",
      "title": "Tétel",
      "close": "Bezárás",
      "loading": "Tétel betöltése",
      "errorTitle": "Ezt a tételt nem sikerült betölteni",
      "postingsTitle": "Könyvelési sorok",
      "residualBadge": "Automatikusan hozzáadva",
      "residualExplanation": "A rendszer ezt a sort az árfolyamkülönbség miatt adta hozzá. Ezt nem te rögzítetted.",
      "editAction": "Szerkesztés",
      "saveAction": "Változtatások mentése",
      "saving": "Mentés folyamatban",
      "cancelEdit": "Mégse",
      "discardTitle": "Elvetjük a módosításokat?",
      "discardConsequence": "A tétel módosításai nincsenek mentve.",
      "keepEditing": "Szerkesztés folytatása",
      "discardAction": "Módosítások elvetése",
      "dateLabel": "Dátum",
      "payeeLabel": "Partner",
      "memoLabel": "Leírás",
      "notesLabel": "Megjegyzés",
      "tagsLabel": "Címkék (vesszővel elválasztva)",
      "postingsEditTitle": "Könyvelési sorok",
      "accountLabel": "Számla",
      "amountLabel": "Összeg",
      "currencyLabel": "Pénznem",
      "postingMemoLabel": "Megjegyzés (opcionális)",
      "addPosting": "Sor hozzáadása",
      "removePosting": "Eltávolítás",
      "pendingRetry": "Az előző kísérlet még feldolgozás alatt van - próbáld újra egy pillanat múlva.",
      "reverseTitle": "Tétel sztornózása",
      "reverseConsequence": "A sztornózás egy új, mai dátumú tételt hoz létre, minden összeg előjelét megfordítva. Ez a tétel változatlan marad - a sztornózás semmit nem töröl, mindkét tétel látható marad a listában.",
      "reverseAction": "Tétel sztornózása",
      "reversing": "Sztornózás folyamatban",
      "deleteTitle": "Tétel törlése",
      "deleteConsequence": "A törlés véglegesen eltávolítja ezt a tételt és a könyvelési sorait, ez nem vonható vissza. Ha meg szeretnéd tartani az előzményekben, inkább sztornózd.",
      "deleteAction": "Tétel törlése",
      "deleting": "Törlés folyamatban",
      "plainTitle": "Hová ment a pénz",
      "plain": {
        "spentOn": "Költve erre:",
        "earnedFrom": "Bevétel innen:",
        "paidFrom": "Fizetve innen:",
        "paidInto": "Befizetve ide:",
        "movedFrom": "Átvezetve innen:",
        "movedTo": "Átvezetve ide:"
      },
      "detailsTitle": "Részletek",
      "dateRequired": "Adj meg dátumot.",
      "memoRequired": "Adj meg megjegyzést.",
      "accountRequired": "Válassz számlát.",
      "amountRequired": "Adj meg összeget.",
      "currencyInvalid": "Adj meg háromkarakteres pénznemkódot.",
      "revaluation": {
        "changesTitle": "Nyereség / veszteség",
        "noMoneyMoved": "Csak értékelés, nem mozgott pénz"
      },
      "createdLabel": "Létrehozva",
      "modifiedLabel": "Módosítva",
      "typeLabel": "Típus"
    },
    "entry": "Tétel",
    "summary": "Összefoglaló",
    "effects": "Hatás",
    "summaryMore": "+{count} további",
    "rowActions": "{entry} műveletei",
    "openAction": "Megnyitás",
    "actions": "Műveletek",
    "effectsOtherCurrencies": "+{count} másik pénznemben",
    "revaluation": {
      "title": "Árfolyam-átértékelés"
    },
    "subtitle": "Minden pénzügyi mozgása egy helyen."
  },
  "contacts": {
    "title": "Kapcsolatok",
    "loading": "Kapcsolatok betöltése",
    "emptyTitle": "Még nincs kapcsolat",
    "emptyBody": "Adj hozzá egy kapcsolatot, hogy nyomon követhessétek, ki kinek tartozik.",
    "errorTitle": "A kapcsolatokat nem sikerült betölteni",
    "detailErrorTitle": "Ezt a kapcsolatot nem sikerült betölteni",
    "errorBody": "Hiba történt a kapcsolatok olvasása közben. Próbáld újra.",
    "retry": "Újra",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "noAccess": "Nincs jogosultságod ennek a főkönyvnek a kapcsolataihoz.",
    "name": "Név",
    "since": "Kapcsolat kezdete",
    "addContact": "Kapcsolat hozzáadása",
    "nameLabel": "Név",
    "notesLabel": "Megjegyzés",
    "save": "Mentés",
    "saving": "Mentés folyamatban",
    "cancel": "Mégse",
    "createErrorBody": "A kapcsolatot nem sikerült létrehozni. Próbáld újra.",
    "editAction": "Szerkesztés",
    "updateErrorBody": "A kapcsolatot nem sikerült menteni. Próbáld újra.",
    "balances": "Egyenlegek",
    "netBalance": "Nettó egyenleg",
    "netBalanceExplain": "Amennyivel neked tartoznak (pozitív), vagy te tartozol (negatív).",
    "owesYou": "Ő tartozik neked",
    "youOwe": "Te tartozol neki",
    "settled": "Rendezve",
    "notes": "Jegyzetek",
    "notesEmpty": "Még nincs jegyzet.",
    "deleteTitle": "Kapcsolat törlése",
    "deleteConfirmTitle": "Törlöd: {name}?",
    "deleteConsequence": "A törlés eltávolítja ezt a kapcsolatot a könyvedből. A rá hivatkozó tételeket nem érinti: a számlája archiválásra, nem törlésre kerül, így az előzmények megmaradnak.",
    "deleteBlockedByBalance": "Ennek a kapcsolatnak legalább egy pénznemben még van egyenlege. Engedd el, amivel tartozik neked, vagy rögzíts visszafizetést, amíg minden pénznem rendezett nem lesz.",
    "deleteAction": "Kapcsolat törlése",
    "deleting": "Törlés folyamatban",
    "deleteErrorBody": "A kapcsolatot nem sikerült törölni. Próbáld újra.",
    "deleteDenied": "Kapcsolatot csak a főkönyv tulajdonosa törölhet.",
    "deleted": "Kapcsolat törölve.",
    "historyTitle": "Tranzakciók",
    "historyEmptyTitle": "Még nincs tranzakció ezzel a partnerrel",
    "historyEmptyBody": "Az ezzel a partnerrel kapcsolatos bejegyzések itt jelennek meg.",
    "historyOwnTitle": "Az ezzel a partnerrel kapcsolatos bejegyzéseid",
    "historyOwnEmptyTitle": "Még nincs bejegyzésed ezzel a partnerrel",
    "historyOwnEmptyBody": "Az általad látható, ezzel a partnerrel kapcsolatos bejegyzések itt jelennek meg.",
    "historyErrorTitle": "A tranzakciókat nem sikerült betölteni",
    "historyErrorBody": "Hiba történt a partner bejegyzéseinek olvasásakor. Próbáld újra.",
    "payback": {
      "action": "Visszafizetés rögzítése",
      "title": "Visszafizetés rögzítése",
      "close": "Bezárás",
      "directionLabel": "Irány",
      "theyPaidMe": "Ő fizetett nekem",
      "iPaidThem": "Én fizettem neki",
      "moneyAccountLabel": "Pénzszámla",
      "amountLabel": "Összeg",
      "currencyLabel": "Pénznem",
      "currencyPlaceholder": "—",
      "currencyHint": "A pénznemet a kiválasztott pénzszámla határozza meg.",
      "dateLabel": "Dátum",
      "memoLabel": "Megjegyzés",
      "memoDefault": "Visszafizetés - {name}",
      "cancel": "Mégse",
      "save": "Visszafizetés rögzítése",
      "saving": "Rögzítés folyamatban",
      "accountRequired": "Válassz pénzszámlát.",
      "amountRequired": "Nullánál nagyobb összeget adj meg.",
      "dateRequired": "Adj meg dátumot.",
      "memoRequired": "Adj meg megjegyzést.",
      "saveError": "A visszafizetést nem sikerült rögzíteni. Próbáld újra.",
      "success": "A visszafizetés rögzítve.",
      "discardTitle": "Elveted ezt a visszafizetést?",
      "discardConsequence": "A nem mentett visszafizetési adatok elvesznek.",
      "keepEditing": "Szerkesztés folytatása",
      "discardAction": "Elvetés"
    },
    "searchLabel": "Kapcsolatok keresése",
    "searchPlaceholder": "Keresés név szerint",
    "sortLabel": "Kapcsolatok rendezése",
    "sort": {
      "name-asc": "Név A–Z",
      "name-desc": "Név Z–A",
      "since-newest": "Legújabb elöl",
      "since-oldest": "Legrégebbi elöl"
    },
    "noMatches": "Nincs a keresésnek megfelelő kapcsolat.",
    "rowActionsHeading": "Műveletek",
    "rowActions": "Műveletek: {name}",
    "openAction": "Kapcsolat megnyitása",
    "subtitle": "Azok az emberek, akikkel tranzakciókat bonyolítasz.",
    "forgiveAction": "Tartozás elengedése",
    "forgiven": "Tartozás elengedve.",
    "nothingToForgive": "{name} nem tartozik neked semmivel, amit elengedhetnél."
  },
  "accounts": {
    "title": "Számlák",
    "subtitle": "Minden számlád, egyenlegük és mozgásuk.",
    "moreActions": "További műveletek",
    "tableLabel": "Számlatükör",
    "loading": "Számlák betöltése",
    "errorTitle": "A számlákat nem sikerült betölteni",
    "errorBody": "Hiba történt a számlatükör olvasása közben. Próbáld újra.",
    "retry": "Újra",
    "empty": "Még nincs számla",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "noAccess": "Nincs jogosultságod ennek a főkönyvnek a számláihoz.",
    "showArchived": "Archivált számlák megjelenítése",
    "showHidden": "Rejtett számlák megjelenítése",
    "detailsLabel": "Számla részletei",
    "archived": "Archivált",
    "archivedNote": "Ez a számla archiválva van.",
    "hidden": "Rejtett",
    "hiddenNote": "Ez a számla rejtve van a szokásos listákban.",
    "hideAction": "Elrejtés",
    "unhideAction": "Elrejtés visszavonása",
    "systemAccountNote": "Ezt a számlát a rendszer kezeli, nem nevezhető át.",
    "accountClass": "Osztály",
    "type": "Típus",
    "currency": "Pénznem",
    "noCurrency": "Nincs pénznem",
    "notPostableNote": "Ennek a számlának alszámlái vannak, a könyvelés azokra kerül.",
    "postableNote": "Nincsenek alszámlái — közvetlenül könyvelhető erre a számlára.",
    "makeDefault": "Legyen alapértelmezett",
    "defaultAccountNote": "Alapértelmezett számlád: a megosztott költségek ebből fizetődnek.",
    "addAccount": "Számla hozzáadása",
    "addSubAccount": "Alszámla hozzáadása",
    "editAccount": "Számla szerkesztése",
    "editAction": "Szerkesztés",
    "presetColors": "Előre beállított színek",
    "iconNames": {
      "BANK": "Bank",
      "CASH": "Készpénz",
      "CARD": "Bankkártya",
      "WALLET": "Pénztárca",
      "CHART": "Diagram",
      "SAVINGS": "Megtakarítás",
      "INVESTMENT": "Befektetés",
      "CRYPTO": "Kriptovaluta",
      "HOME": "Otthon",
      "SHOPPING": "Bevásárlás",
      "GIFT": "Ajándék",
      "GLOBAL": "Globális"
    },
    "archiveAction": "Archiválás",
    "restoreAction": "Visszaállítás",
    "archiveConfirmPrompt": "Archiválod ezt a számlát?",
    "archiveFailed": "Az archiválás nem sikerült. Próbáld újra.",
    "restoreFailed": "A visszaállítás nem sikerült. Próbáld újra.",
    "reconcileFailed": "Az egyeztetést nem sikerült elindítani. Próbáld újra.",
    "confirm": "Megerősítés",
    "cancel": "Mégse",
    "code": "Kód",
    "names": "Név",
    "nameEn": "Angol",
    "nameHu": "Magyar",
    "icon": "Ikon",
    "color": "Szín",
    "parentAccount": "Szülőszámla",
    "create": "Létrehozás",
    "creating": "Létrehozás",
    "update": "Mentés",
    "updating": "Mentés",
    "codeAlreadyUsed": "Ez a kód már használatban van ebben a főkönyvben.",
    "missingLocaleError": "Az angol és a magyar név is kötelező.",
    "createErrorGeneral": "A számlát nem sikerült létrehozni. Próbáld újra.",
    "updateErrorGeneral": "A számlát nem sikerült frissíteni. Próbáld újra.",
    "reconcileTitle": "Egyeztetés",
    "reconcileHistoryTitle": "Egyeztetési előzmények",
    "reconcileLoadingHistory": "Egyeztetési előzmények betöltése…",
    "reconcileHistoryError": "Az egyeztetési előzményeket nem sikerült betölteni.",
    "reconcileHistoryEmpty": "Még nincsenek egyeztetések.",
    "reconcileOutcomeMatched": "Egyenlegek egyeznek",
    "reconcileOutcomeCorrected": "Javítás könyvelve",
    "reconcileOutcomeReversed": "Javítás visszavonva",
    "reconcileViewEntry": "Bejegyzés megtekintése",
    "columnAccount": "Számla",
    "holdsColumn": "Saját pénznem",
    "columnBalance": "Egyenleg",
    "accountCount": "{count} számla",
    "subAccountCount": "{count} alszámla",
    "searchLabel": "Számlák keresése",
    "searchPlaceholder": "Számlák keresése név vagy kód alapján",
    "allClasses": "Minden osztály",
    "allTypes": "Minden típus",
    "classTotals": "Egyenleg-összesítő",
    "reconcileAccounts": "Számlák egyeztetése",
    "resumeReconciliation": "Egyeztetés folytatása",
    "reconciliationOpenBanner": "Egyeztetés van folyamatban ({count} számla ellenőrizve eddig).",
    "reconcileViewSession": "Munkamenet megtekintése",
    "kind": "Számla fajtája",
    "kinds": {
      "bank": "Bankszámla",
      "cash": "Készpénz",
      "savings": "Megtakarítás",
      "investments": "Befektetések",
      "crypto": "Kripto",
      "creditCard": "Hitelkártya",
      "expense": "Kiadási kategória",
      "income": "Bevételi kategória"
    },
    "nameRequired": "Adj nevet a számlának.",
    "codeRequired": "Add meg a kódot.",
    "advanced": "Speciális",
    "simpleMode": "Egyszerű",
    "classes": {
      "ASSET": "Eszközök",
      "LIABILITY": "Kötelezettségek",
      "INCOME": "Bevételek",
      "EXPENSE": "Kiadások",
      "EQUITY": "Saját tőke"
    },
    "types": {
      "CASH": "Készpénz",
      "SAVINGS": "Megtakarítás",
      "STOCKS": "Részvények",
      "CRYPTO": "Kripto",
      "BROKER_CASH": "Brókerszámla készpénz",
      "FX": "Deviza",
      "EMERGENCY_FUND": "Vésztartalék",
      "CONTACT": "Kapcsolat",
      "LOAN": "Hitel",
      "INTEREST": "Kamat",
      "FEE": "Díj",
      "OPENING": "Nyitó egyenleg",
      "RECONCILIATION": "Egyeztetés",
      "PNL": "Eredmény",
      "OTHER": "Általános"
    },
    "groupToggle": "Számlacsoport",
    "groupHint": "Más számlákat tartalmaz, például több számlát egy bank alatt. A számlákat ezután adhatod hozzá.",
    "chooseCurrency": "Válassz pénznemet",
    "currencyRequired": "Válassz pénznemet a számlához.",
    "parentRequired": "Válaszd ki, hová kerüljön a számla.",
    "columnType": "Típus",
    "groupBadge": "Csoport",
    "groupNote": "Ez egy csoport: más számlákat tartalmaz, és közvetlenül nem könyvelhető rá.",
    "errors": {
      "parent_required": "Válaszd ki, hová kerüljön a számla.",
      "parent_class_mismatch": "A számlának és a szülőjének azonos fajtájúnak kell lennie: eszköz eszköz alá, kiadás kiadás alá és így tovább.",
      "parent_not_allowed": "Ez alá a számla alá nem vehető fel számla. Válassz inkább csoportot.",
      "parent_archived": "A szülőszámla archivált. Állítsd vissza, vagy válassz másikat.",
      "parent_not_found": "A szülőszámla már nem létezik. Válassz másikat.",
      "group_class_not_allowed": "Csak eszköz- és kötelezettségszámla lehet csoport.",
      "code_must_extend_parent": "A kódnak a szülőszámla kódjával kell kezdődnie.",
      "type_not_allowed_for_class": "Ez a típus nem érhető el ennél a számlafajtánál.",
      "currency_not_supported": "Ez a pénznem ebben a telepítésben nem támogatott."
    },
    "openAccountPage": "{name} megnyitása",
    "actionsLabel": "Műveletek: {name}",
    "openAction": "Megnyitás",
    "columnActions": "Műveletek"
  },
  "membership": {
    "title": "Tagok",
    "loading": "Tagok betöltése",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "noAccess": "Nincs jogosultságod ennek a főkönyvnek a tagjait kezelni.",
    "errorTitle": "A tagokat nem sikerült betölteni",
    "errorBody": "Hiba történt a tagság olvasása közben. Próbáld újra.",
    "retry": "Újra",
    "membersTitle": "Tagok",
    "membersEmpty": "Még nincs tag.",
    "subject": "E-mail",
    "role": "Szerepkör",
    "addMemberTitle": "Tag közvetlen hozzáadása",
    "addMemberBody": "Olyan személyhez, akinek már van Taler fiókja. Azonnal hozzáférést kap, meghívás nélkül.",
    "addMemberAction": "Tag hozzáadása",
    "addMemberError": "Nem sikerült hozzáadni ezt a tagot. Ellenőrizd az e-mail címet, és próbáld újra.",
    "invitationsTitle": "Meghívók",
    "invitationsEmpty": "Még nincs meghívó.",
    "invitedSubject": "E-mail",
    "status": "Állapot",
    "expiresAt": "Lejár",
    "statusPending": "Függőben",
    "statusAccepted": "Elfogadva",
    "statusRevoked": "Visszavonva",
    "revoke": "Visszavonás",
    "revokeConfirmBody": "A már elküldött link azonnal érvénytelen lesz. Ez nem vonható vissza.",
    "revokeConfirmAction": "Meghívó visszavonása",
    "revokeCancel": "Mégse",
    "revokeError": "Nem sikerült visszavonni ezt a meghívót. Próbáld újra.",
    "inviteTitle": "Új személy meghívása",
    "inviteBody": "Linket küldünk e-mailben. A csatlakozáskor kapja meg az itt kiválasztott szerepkört.",
    "inviteAction": "Meghívó küldése",
    "inviteError": "Nem sikerült elküldeni ezt a meghívót. Ellenőrizd az e-mail címet, és próbáld újra.",
    "roleDescription": {
      "OWNER": "Teljes irányítás e főkönyv felett, beleértve a tagságot, a beállításokat és a számlaarchívumot.",
      "PARTNER": "Minden, kivéve a tagság, a főkönyv beállításai és a számlaarchívum kezelését.",
      "OBSERVER": "Csak olvasási hozzáférés minden tételhez, számlanévhez és egyenleghez.",
      "AGGREGATES_VIEWER": "Kizárólag az áttekintő összesítő adatok - nincs tétel, nincs egyenleg.",
      "CONTRIBUTOR": "Tételeket rögzíthet, és csak a sajátjait látja - nincs egyenleg, nincs áttekintő, nincs összesítés."
    },
    "remove": "Eltávolítás",
    "removeConfirmBody": "{subject} azonnal elveszíti a hozzáférést ehhez a főkönyvhöz. A tételei megmaradnak a naplóban, továbbra is hozzá rendelve. Ez nem vonható vissza.",
    "removeConfirmAction": "Tag eltávolítása",
    "removeCancel": "Mégse",
    "removeError": "Nem sikerült eltávolítani ezt a tagot. Próbáld újra.",
    "changeRoleError": "Nem sikerült megváltoztatni ennek a tagnak a szerepkörét. Próbáld újra.",
    "lastOwnerNote": "A főkönyv egyetlen tulajdonosa. Adj hozzá másik tulajdonost, mielőtt eltávolítod vagy megváltoztatod ezt a szerepkört.",
    "roleName": {
      "OWNER": "Tulajdonos",
      "PARTNER": "Partner",
      "OBSERVER": "Megtekintő",
      "AGGREGATES_VIEWER": "Csak összesítők",
      "CONTRIBUTOR": "Közreműködő"
    },
    "roleFor": "{subject} szerepköre"
  },
  "invitationAccept": {
    "title": "Főkönyv meghívó",
    "body": "Meghívást kaptál egy Taler főkönyvhöz. Az elfogadás előtt bejelentkezést kérhetünk.",
    "acceptAction": "Meghívó elfogadása",
    "accepting": "Meghívó elfogadása folyamatban",
    "successTitle": "Meghívó elfogadva",
    "successBody": "Mostantól {role} hozzáférésed van ehhez a főkönyvhöz.",
    "continueAction": "Tovább a főkönyvhöz",
    "errorTitle": "Ezt a meghívót nem sikerült elfogadni",
    "errorBody": "A link lejárt, már felhasználták, vagy visszavonták. Kérj új linket attól, aki meghívott."
  },
  "entries": {
    "title": "Új tételek",
    "backToTransactions": "Vissza a tranzakciókhoz",
    "noLedger": "Egyelőre nincs elérhető könyvelés a fiókodhoz.",
    "noAccess": "Nincs jogosultságod tételt könyvelni ebbe a könyvelésbe.",
    "tab": {
      "expense": "Kiadás",
      "income": "Bevétel",
      "transfer": "Saját számlák között",
      "other": "Egyéb"
    },
    "date": "Dátum",
    "amount": "Összeg",
    "memo": "Megjegyzés",
    "payee": "Kereskedő",
    "tags": "Címkék",
    "removeTag": "{tag} címke eltávolítása",
    "tagUsageCount": "{count}×",
    "rowActions": "Sor műveletei",
    "accountLabel": {
      "EXPENSE": "Számla",
      "INCOME": "Számla",
      "TRANSFER": "Forrás számla"
    },
    "counterLabel": {
      "EXPENSE": "Kategória",
      "INCOME": "Forrás",
      "TRANSFER": "Cél számla"
    },
    "addRow": "Újabb tétel hozzáadása",
    "shortcutEnter": "Enter",
    "addRowHint": "Egy kész sorban az {key} billentyű új tételt nyit.",
    "addSplit": "+ Felosztás",
    "removeRow": "Sor eltávolítása",
    "removeSplit": "Felosztás eltávolítása",
    "currencyMismatch": "Ez a számla csak a sortól eltérő devizanemet fogad el.",
    "splitTotal": "Felosztás összesen",
    "deltaFor": "Változás: {account}",
    "deltaHint": "Ez a köteg által okozott változás az egyes számlákon, nem a végső egyenleg - a tényleges egyenleget könyveléskor ellenőrzi az adatbázis, a negatív egyenleg pedig természetes, nem hiba.",
    "submitErrorGeneric": "Hiba történt könyvelés közben. Próbáld újra.",
    "posting": "Könyvelés…",
    "postOne": "1 tétel könyvelése",
    "postCount": "{count} tétel könyvelése",
    "noCompleteRows": "Tölts ki egy sort a könyveléshez.",
    "mostUsed": "Leggyakrabban használt ebben a könyvelésben",
    "pickerFavourite": "Kedvenc",
    "pickerRecent": "Leggyakoribb",
    "pickerAccounts": "Számlák",
    "pickerCategories": "Kategóriák",
    "pickerContacts": "Kapcsolatok",
    "pickerTransferAccounts": "Számlák",
    "pickerNoMatches": "Nincs egyező számla",
    "pickerPlaceholder": "Válassz számlát",
    "pickerSearchHint": "Írj a kereséshez",
    "pickerCurrencyOnly": "Csak {currency}",
    "pickerNotAvailable": "Itt nem választható",
    "pickerCreateContact": "Kapcsolat létrehozása: „{name}”",
    "pickerUseExisting": "Meglévő kapcsolat: „{name}”",
    "pickerNewContact": "Új kapcsolat",
    "pickerCreating": "Kapcsolat létrehozása…",
    "pickerCreateFailed": "A kapcsolat létrehozása nem sikerült. Próbáld újra.",
    "newContactTitle": "Új kapcsolat",
    "newContactNotes": "Megjegyzés (nem kötelező)",
    "everythingElse": "Minden más találat",
    "frecencyToday": "ma",
    "frecencyYesterday": "tegnap",
    "frecencyDaysAgo": "{count} napja",
    "frecencyCount": "{count}×",
    "frecencyCountWhen": "{count}× · {when}",
    "postingAccount": "Számla",
    "signedAmount": "Előjeles összeg",
    "addLine": "+ Sor hozzáadása",
    "balance": "Egyenleg",
    "notBalanced": "A tételsoroknak nullára kell kiegyenlíteniük a könyveléshez.",
    "postEntry": "Tétel könyvelése",
    "posted": "Könyvelve",
    "thisBatch": "Ez a köteg",
    "thisEntry": "Ez a tétel",
    "readyCount": "{count} rögzíthető",
    "alreadyInLedger": "Már a főkönyvben",
    "alreadyInLedgerUnavailable": "A legutóbbi tételek nem tölthetők be.",
    "needsDetailsCount": "{count} részletekre vár",
    "blockedCount": "{count} nem könyvelhető",
    "incompleteCount": "{count} nincs kitöltve",
    "batchWaits": "{waiting}. A köteg akkor könyvelhető, ha minden sor kész.",
    "extension": {
      "notCarried": "{label}: nem kerül rögzítésre",
      "splitsNotCarried": "{label} nem osztható fel - töröld a további sorokat.",
      "details": "Részletek",
      "closeDetails": "Részletek bezárása",
      "attachFailed": "A tétel könyvelve, de ez nem mentődött: {label}. {detail}",
      "retry": "Újra",
      "notCarriedShort": "Nem rögzül"
    },
    "fx": {
      "label": "Devizaváltás",
      "needsReceived": "Add meg a kapott összeget ({currency})",
      "receivedLabel": "Kapott összeg",
      "impliedRate": "számított árfolyam: {rate}",
      "receivedAriaLabel": "Kapott összeg ({currency})"
    }
  },
  "splitExpense": {
    "title": "Számla felosztása",
    "subtitle": "Bontsd sorokra a számlát, és irányítsd az egyes sorokat kategóriára vagy személyre.",
    "date": "Dátum",
    "paidFrom": "Fizetve innen",
    "payee": "Kereskedő",
    "total": "Számla összesen",
    "remaining": "Felosztásra váró összeg",
    "remainingShort": "A sorok még nem adják ki az összesen összeget.",
    "remainingOver": "A sorok többet adnak ki, mint az összesen összeg.",
    "splitEvenly": "Egyenlő felosztás",
    "setAllCategory": "Kategória",
    "applyToAll": "Alkalmaz mindenkire",
    "targetColumn": "Kategória / Kapcsolat",
    "addLine": "+ Sor hozzáadása",
    "submit": "Számla felosztása",
    "posting": "Könyvelés…",
    "posted": "Számla felosztva",
    "notBalanced": "A soroknak ki kell adniuk a számla összegét a könyveléshez."
  },
  "paymentAccount": {
    "field": "Fizetési számla",
    "gateExplanation": "Válaszd ki, melyik számláról legyenek fizetve a számlafelosztás tételei ebben a főkönyvben. Ez egyszer kerül beállításra és minden sorra érvényes - később a Számlák oldalon a „Legyen alapértelmezett” gombbal módosítható.",
    "change": "Módosítás",
    "save": "Mentés",
    "saving": "Mentés…"
  },
  "exports": {
    "title": "Exportok",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "noAccess": "Nincs jogosultságod ennek a főkönyvnek az exportálásához.",
    "fromDate": "Ettől",
    "untilDate": "Eddig",
    "request": "Export kérése",
    "requesting": "Kérés folyamatban…",
    "invalidRange": "A kezdő dátum nem lehet a záró dátum után.",
    "createError": "Az exportot nem sikerült elindítani. Próbáld újra.",
    "loading": "Exportok betöltése",
    "errorTitle": "Az exportokat nem sikerült betölteni",
    "errorBody": "Hiba történt az export előzmények olvasása közben. Próbáld újra.",
    "retry": "Újra",
    "emptyTitle": "Még nincs export",
    "emptyBody": "Kérj egy exportot egy dátumtartományra, hogy CSV fájlként letölthesd.",
    "requested": "Kérve",
    "range": "Időszak",
    "requestedBy": "Kérte",
    "actions": "Műveletek",
    "download": "Letöltés",
    "downloading": "Letöltés…",
    "unknownError": "Az export ismeretlen okból nem sikerült.",
    "tableRegion": "Exportok táblázata, görgethető",
    "status": {
      "label": "Állapot",
      "QUEUED": "Várakozik",
      "RUNNING": "Generálás…",
      "COMPLETED": "Kész",
      "FAILED": "Sikertelen"
    }
  },
  "merchants": {
    "title": "Kereskedők",
    "name": "Név",
    "firstSeen": "Első előfordulás",
    "searchLabel": "Kereskedők keresése",
    "searchPlaceholder": "Kereskedők keresése…",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "noAccess": "Nincs jogosultságod ennek a főkönyvnek a kereskedőihez.",
    "loadError": "A kereskedőket nem sikerült betölteni.",
    "retry": "Próbáld újra",
    "emptyState": "A kereskedők itt fognak megjelenni, amint egy napló bejegyzés megnevez egyet.",
    "noResults": "Nincs a keresésnek megfelelő kereskedő.",
    "loadMore": "Továbbiak betöltése",
    "loadingMore": "Betöltés…",
    "aliases": "Álnevek",
    "aliasesToggleShow": "Álnevek megjelenítése",
    "aliasesToggleHide": "Álnevek elrejtése",
    "aliasesEmpty": "Nincsenek álnevek.",
    "aliasAdd": "Álnév hozzáadása",
    "aliasPlaceholder": "Álnév",
    "aliasAdding": "Hozzáadás…",
    "aliasRemove": "{alias} álnév eltávolítása",
    "aliasRemoveConfirm": "'{alias}' eltávolítása?",
    "aliasRemoveConfirmYes": "Eltávolítás",
    "aliasRemoveConfirmCancel": "Mégse",
    "aliasRemoving": "Eltávolítás…",
    "aliasErrorAlreadyExists": "Ez már {name} egyik álneve.",
    "aliasErrorCollides": "Ez a név már egy másik kereskedőhöz tartozik.",
    "aliasErrorGeneric": "Az álnevet nem sikerült hozzáadni.",
    "merge": "Egyesítés",
    "mergeInto": "{name} egyesítése ezzel…",
    "mergeDestinationLabel": "Egyesítés ezzel",
    "mergeDestinationPlaceholder": "Válassz kereskedőt",
    "mergeDestinationSearchLabel": "Kereskedők keresése",
    "mergeDestinationEmpty": "Nincs egyező kereskedő.",
    "mergeCounting": "Bejegyzések számolása…",
    "mergeCountError": "A bejegyzések számát nem sikerült megállapítani. Próbáld újra egyesítés előtt.",
    "mergeConsequenceOne": "Ez 1 bejegyzést helyez át {source} kereskedőtől {destination} kereskedőhöz, és törli {source} kereskedőt. Ez nem vonható vissza.",
    "mergeConsequenceMany": "Ez {count} bejegyzést helyez át {source} kereskedőtől {destination} kereskedőhöz, és törli {source} kereskedőt. Ez nem vonható vissza.",
    "mergeConsequenceNone": "Ez törli {source} kereskedőt, és a nevét {destination} kereskedő álneveként megőrzi. Ez nem vonható vissza.",
    "mergeContinue": "Tovább",
    "mergeBack": "Vissza",
    "mergeConfirm": "Kereskedők egyesítése",
    "mergeConfirmAction": "Egyesítés és {source} törlése",
    "mergeCancel": "Mégse",
    "mergeSubmitting": "Egyesítés…",
    "mergeError": "Az egyesítés nem sikerült.",
    "mergeSuccess": "{source} egyesítve lett {destination} kereskedővel."
  },
  "dashboard": {
    "title": "Kezdőlap",
    "loading": "Kezdőlap betöltése",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "noAccess": "Nincs jogosultságod ennek a főkönyvnek a kezdőlapjához.",
    "errorTitle": "A kezdőlapot nem sikerült betölteni",
    "errorBody": "Hiba történt a kezdőlap olvasása közben. Próbáld újra.",
    "panelErrorTitle": "Ezt a részt nem sikerült betölteni",
    "retry": "Újra",
    "netWorth": "Nettó vagyon",
    "cash": "Készpénz",
    "totalLent": "Összes kölcsönadott",
    "totalBorrowed": "Összes felvett kölcsön",
    "refresh": "Frissítés",
    "income": "Havi bevétel",
    "expense": "Havi kiadás",
    "thisMonth": "Hónap eddig",
    "incomeShort": "Bevétel",
    "expenseShort": "Kiadás",
    "netResult": "Nettó havi eredmény",
    "netResultShort": "Nettó",
    "windowRange": "{from} – {until}",
    "comparedWith": "{current}, az előző hónap ugyanezen szakaszához képest: {previous}",
    "vsSamePointLastMonth": "előző hónap, ugyanekkor",
    "headlineOkay": "Összességében jól állsz",
    "headlineBehind": "Az előző hónaphoz képest elmaradsz",
    "savingsRate": "Megtakarítási arány",
    "savingsRateBefore": "Előző hónap, ugyanekkor: {rate}",
    "noSavingsRate": "Nincs megtakarítási arány bevétel nélkül",
    "saved": "Megtakarítva",
    "spent": "Elköltve",
    "cashFlow": "Pénzforgalom",
    "spending": "Kiadások kategóriánként",
    "noSpending": "Ebben az időszakban nincs kiadás.",
    "otherCategory": "Egyéb",
    "accountMovement": "Számlamozgás",
    "account": "Számla",
    "moneyIn": "Beérkezett",
    "moneyOut": "Kifizetett",
    "transfers": "Átutalások",
    "noAccountMovement": "Ebben az időszakban nincs számlamozgás.",
    "recentTransactions": "Legutóbbi tételek",
    "netWorthHistoryTitle": "Készpénz és nettó vagyon, teljes előzmény",
    "netWorthHistoryLabel": "Nettó vagyon és készpénz {from} és {to} között: a nettó vagyon {fromValue} értékről {toValue} értékre változott",
    "netWorthHistoryResolutionDaily": "Naponta egy pont",
    "netWorthHistoryResolution": "{days} naponta egy pont"
  },
  "transfers": {
    "inboxTitle": "Beérkezett",
    "inboxSubtitle": "Kérések és tevékenység az összekötött főkönyveidtől.",
    "inboxLoading": "Függőben lévő átutalások betöltése",
    "inboxErrorTitle": "A függőben lévő átutalásokat nem sikerült betölteni",
    "inboxErrorBody": "Hiba történt a beérkezett átutalások olvasása közben. Próbáld újra.",
    "inboxEmptyTitle": "Nincs függőben lévő átutalás",
    "inboxEmptyBody": "A más főkönyvekből érkező átutalások itt fognak várni a döntésedre.",
    "inboxEmptyRelationshipHint": "Egy főkönyv csak akkor küldhet átutalást, ha van vele kapcsolatod.",
    "inboxEmptyRelationshipLink": "Kapcsolatok kezelése",
    "retry": "Újra",
    "noAccess": "Nincs jogosultságod ennek a főkönyvnek az átutalásaihoz.",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "depositInto": "Jóváírás ide",
    "theChosenAccount": "a kiválasztott számlára",
    "acceptConsequence": "Az elfogadás {amount} összeget ír jóvá ide: {account}, ebben a főkönyvben. Ez nem vonható vissza.",
    "accept": "Elfogadás",
    "rejectConsequence": "Az elutasítás törli az átutalást; {ledger} megtartja a pénzt. Ez nem vonható vissza.",
    "reject": "Elutasítás",
    "cancel": "Mégse",
    "fxLeg": "küldve: {amount}",
    "impliedRate": "számított árfolyam: {rate}",
    "recentlyAcceptedTitle": "Nemrég elfogadva",
    "reverseConsequence": "A visszavonás egy ellentétes tételt rögzít mindkét főkönyvben. Ez nem vonható vissza.",
    "reverse": "Visszavonás",
    "fromLedger": "Feladó: {ledger}",
    "extension": {
      "label": "Főkönyvek között · {ledger}",
      "bothForeignBlocked": "Válassz egy ebben a főkönyvben lévő számlát legalább az egyik oldalra.",
      "needsTargetAmount": "Add meg a kapott összeget ({currency})",
      "targetAmountLabel": "Ennyit kapnak",
      "targetAmountAriaLabel": "Kapott összeg ({currency})",
      "proposedToast": "Elküldve {ledger} részére - az elfogadásukra vár."
    }
  },
  "loans": {
    "title": "Kölcsönök",
    "loading": "Kölcsönök betöltése",
    "emptyTitle": "Még nincs kölcsön",
    "emptyBody": "Adj hozzá egy kölcsönt, hogy nyomon követhesd a tőkét, a kamatot és a törlesztéseket.",
    "errorTitle": "A kölcsönöket nem sikerült betölteni",
    "detailErrorTitle": "Ezt a kölcsönt nem sikerült betölteni",
    "errorBody": "Hiba történt a kölcsön olvasása közben. Próbáld újra.",
    "retry": "Újra",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "noAccess": "Nincs jogosultságod ennek a főkönyvnek a kölcsöneihez.",
    "name": "Név",
    "addLoan": "Kölcsön hozzáadása",
    "nameLabel": "Név",
    "currency": "Pénznem",
    "selectCurrency": "Válassz pénznemet",
    "originalPrincipal": "Felvett összeg",
    "outstandingPrincipal": "Még tartozás (kamat nélkül)",
    "remainingBalance": "Fennmaradó egyenleg",
    "accruedInterest": "Felhalmozott kamat",
    "annualInterestRate": "Éves kamatláb",
    "drawdownDate": "Kézhezvétel dátuma",
    "nextAccrualDate": "Következő kamatfizetés",
    "accrualCount": "Eddigi kamatterhelések",
    "save": "Mentés",
    "saving": "Mentés folyamatban",
    "cancel": "Mégse",
    "invalidAmount": "Ellenőrizd az összeget és a kamatlábat: egyszerű tizedes számnak kell lenniük.",
    "invalidInterestRate": "Adj meg egy 0 és 100 közötti kamatlábat.",
    "createErrorBody": "A kölcsönt nem sikerült létrehozni. Próbáld újra.",
    "paymentHistory": "Törlesztési előzmények",
    "noPayments": "Még nincs rögzített törlesztés.",
    "paymentDate": "Dátum",
    "paymentAmount": "Összeg",
    "principalPortion": "Tőke",
    "interestPortion": "Kamat",
    "recordPayment": "Törlesztés rögzítése",
    "recording": "Rögzítés folyamatban",
    "sourceAccount": "Fizetve innen",
    "selectSourceAccount": "Válassz számlát",
    "paymentErrorBody": "A törlesztést nem sikerült rögzíteni. Próbáld újra.",
    "projectedInterest": "Kamatfelhalmozás előrejelzése",
    "projectionHorizon": "Időtáv",
    "monthsAhead": "{count} hónap",
    "projectionExplanation": "Ez egy becslés, nem tény: azt feltételezi, hogy nem érkezik további törlesztés, és a fennálló tőke pontosan annyi marad, mint ma. A valós érték megváltozik, amint törlesztést rögzítesz.",
    "noProjections": "Erre az időtávra nincs elérhető becslés.",
    "projectedOn": "Becsült érték: {date}",
    "projectionChartLabel": "Becsült kamat {from}-tól {to}-ig, elérve {toValue}",
    "repaid": "Törlesztve",
    "notYetDrawn": "Még nincs felvéve",
    "recordDrawdown": "Folyósítás rögzítése",
    "drawdownAmount": "Kapott összeg",
    "drawdownAccount": "Ide érkezett",
    "drawdownExplanation": "A tőkét a kiválasztott számlára könyveli, a hitel folyósítási dátumával.",
    "drawdownErrorBody": "A folyósítást nem sikerült rögzíteni. Próbáld újra.",
    "repaidOf": "{repaid} / {original}",
    "extension": {
      "hint": "Hiteltörlesztés",
      "paymentLabel": "Hiteltörlesztés · {name}",
      "borrowingLabel": "Hitelfelvétel · {name}",
      "interestLabel": "Hitelkamat · {name}",
      "borrowingBlocked": "A Taler egyelőre nem rögzít további hitelfelvételt.",
      "interestBlocked": "A hitel kamatát a Taler havonta automatikusan könyveli; ha itt is rögzíted, kétszer számolódna.",
      "currencyMismatch": "A hitelt {currency} számláról fizesd",
      "interestFirst": "Először a kamat",
      "overpayment": "Túlfizetés",
      "estimateNote": "A mai felhalmozott kamatból becsülve; a végleges felosztást a Taler könyveléskor számolja ki."
    },
    "overpaymentPortion": "Túlfizetés",
    "addLoanTitle": "Kölcsön hozzáadása",
    "subtitle": "Kölcsöneid, törlesztéseid és kamataid követése.",
    "summary": {
      "totalOutstanding": "Fennálló összeg",
      "monthlyPayments": "Havi törlesztések",
      "estimatedInterest": "Összes kamat (becsült)"
    },
    "remaining": "{amount} hátra van",
    "termElapsed": "A futamidő {percent}%-a telt el",
    "overdue": "Lejárt",
    "active": "Aktív",
    "notSet": "Nincs megadva",
    "endDate": "Lejárat",
    "endDateOptional": "Lejárat (opcionális)",
    "lender": "Hitelező",
    "lenderOptional": "Hitelező (opcionális)",
    "lenderPlaceholder": "pl. CIB Bank",
    "rateType": "Fix vagy változó",
    "rateTypeNotSet": "Nincs megadva",
    "rateFixed": "Fix",
    "rateVariable": "Változó",
    "startDate": "Kezdő dátum",
    "interestRate": "Kamat",
    "monthlyPayment": "Havi törlesztő",
    "monthlyPaymentOptional": "Havi törlesztő (opcionális)",
    "loanTypeLabel": "Kölcsön típusa",
    "loanType": {
      "MORTGAGE": "Jelzáloghitel",
      "CAR": "Autóhitel",
      "STUDENT": "Diákhitel",
      "PERSONAL": "Személyi kölcsön",
      "OTHER": "Egyéb"
    },
    "loanDetails": "Kölcsön adatai",
    "initialAmountSuffix": "kezdeti összeg",
    "viewAll": "Összes megtekintése",
    "createLoan": "Kölcsön létrehozása",
    "editTerms": "Feltételek szerkesztése",
    "editTermsTitle": "Kölcsön feltételei",
    "termsErrorBody": "A feltételeket nem sikerült menteni. Próbáld újra.",
    "deleteTitle": "Kölcsön törlése",
    "deleteConsequence": "Ez végleg törli a kölcsönt és az üres számláit. Törlesztést vagy felhalmozott kamatot tartalmazó kölcsön nem törölhető.",
    "deleteAction": "Kölcsön törlése",
    "deleting": "Törlés…",
    "deleteErrorBody": "A kölcsönt nem sikerült törölni. Próbáld újra.",
    "actionsLabel": "Műveletek: {name}",
    "tabs": {
      "overview": "Áttekintés",
      "payments": "Törlesztések",
      "interest": "Kamat",
      "details": "Részletek"
    }
  },
  "relationships": {
    "connectCta": "Főkönyv összekötése",
    "close": "Bezárás",
    "title": "Kapcsolatok",
    "intro": "Kösd össze a főkönyveket, hogy pénzt küldhessenek egymásnak.",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "noAccess": "Nincs jogosultságod ennek a főkönyvnek a kapcsolatait kezelni.",
    "receivedTitle": "Rád várnak",
    "receivedEmpty": "Nincs rád váró kérés.",
    "proposalFrom": "{ledger} össze szeretne kapcsolódni ezzel a főkönyvvel",
    "connectionRequest": "Kapcsolódási kérés",
    "acceptConsequence": "Az elfogadás azonnal összeköti a két főkönyvet. Ez innen nem vonható vissza.",
    "accept": "Elfogadás",
    "decline": "Elutasítás",
    "establishedTitle": "Összekötött főkönyvek",
    "establishedEmpty": "Még nincs összekötött főkönyv. Kapcsolj össze egyet, hogy pénzt küldhess.",
    "sentTitle": "Általad küldött",
    "sentEmpty": "Még nem kértél összekapcsolást.",
    "proposalTo": "Ide: {ledger}",
    "requestedOn": "Kérve: {date}",
    "statusProposed": "Várakozik",
    "statusAccepted": "Elfogadva",
    "statusDeclined": "Elutasítva",
    "settlement": "Hogyan mozogjon a pénz?",
    "settlementContribution": "Hozzájárulás",
    "settlementContributionHint": "Egyirányú pénzátadás, amelyet később nem kell visszafizetni.",
    "settlementReimbursementHint": "Visszafizet egy költséget, amelyet a másik főkönyv fedezett helyetted.",
    "settlementReimbursement": "Visszatérítés",
    "disclosure": "{ledger} látni fogja ezt a javaslatot, azt is, hogy {source} küldte, és a választott elszámolási módot. Elfogadhatja vagy elutasíthatja; semmi nem kapcsolódik össze, amíg el nem fogadja.",
    "propose": "Javaslat küldése",
    "proposeFailed": "A javaslatot nem sikerült elküldeni. Próbáld újra.",
    "proposeToSelf": "Ez a saját ledgered kódja. Javaslathoz másik ledger kell.",
    "ownCodeTitle": "A ledger kódod",
    "ownCodeHint": "Oszd meg ezt a kódot, hogy egy másik ledger tulajdonosa kapcsolódhasson ehhez a ledgerhez. Csak ennek a ledgernek a nevét látják.",
    "ownCodeValue": "Ledger kód: {code}",
    "copyCode": "Kód másolása",
    "copied": "Másolva",
    "rotateCode": "Új kód kérése",
    "rotateConsequence": "A jelenlegi kód azonnal érvénytelen lesz. A már kapcsolódott ledgerek kapcsolata megmarad.",
    "rotateConfirm": "Új kód kérése",
    "rotateKeep": "Maradjon a kód",
    "rotateFailed": "A kódot nem sikerült megváltoztatni. Próbáld újra.",
    "connectTitle": "Ledger összekötése",
    "connectIntro": "Írd be az öt karakteres kódot, amelyet a másik ledger tulajdonosa megosztott veled.",
    "codeLabel": "Ledger kód",
    "codeHint": "Öt betű vagy szám. Nem számít a kis- és nagybetű. A 0, 1, I és O nem szerepel a kódokban.",
    "codeInvalid": "Írj be öt betűt vagy számot. A kódokban nem szerepel a 0, 1, I és O.",
    "findLedger": "Ledger keresése",
    "codeNotFound": "Nincs ilyen kódú ledger. Ellenőrizd a másik ledger tulajdonosával.",
    "codeRateLimited": "Az elmúlt időben túl sok kódot ellenőriztél. Várj legfeljebb egy órát, aztán próbáld újra.",
    "codeLookupFailed": "A ledgert nem sikerült megtalálni. Próbáld újra.",
    "previewTitle": "Ledger megtalálva",
    "previewLine": "Összekötöd ezzel: {ledger}?",
    "unknownLedger": "Másik ledger",
    "loadFailed": "Az összekötött ledgereket nem sikerült betölteni.",
    "retry": "Újrapróbálás"
  },
  "reporting": {
    "title": "Kimutatások",
    "netWorthTitle": "Nettó vagyon",
    "periodRollupTitle": "Időszakonként",
    "periodRollupPeriodColumn": "Időszak",
    "rollupTitle": "Szülő összesítés",
    "noLedger": "Ehhez a fiókhoz még nem tartozik könyvelés.",
    "noAccess": "Nincs jogosultságod a könyvelés jelentéseinek megtekintéséhez.",
    "loading": "Jelentés betöltése",
    "errorTitle": "A jelentés nem tölthető be",
    "retry": "Próbáld újra",
    "displayCurrency": "Pénznem",
    "accountClass": "Osztály",
    "classExpense": "Kiadás",
    "classIncome": "Bevétel",
    "bucket": "Bontás",
    "bucketDay": "Nap",
    "bucketWeek": "Hét",
    "bucketMonth": "Hónap",
    "bucketYear": "Év",
    "date": "Dátum",
    "from": "Ettől",
    "until": "Eddig",
    "stepEarlier": "Előző hónap",
    "stepLater": "Következő hónap",
    "netWorthAsOf": "Nettó vagyon {date} napon",
    "bucketColumnWeek": "{year}/{week}. hét",
    "pivotAmountsIn": "Az összegek {currency} pénznemben.",
    "pivotTotalRow": "Összesen",
    "periodRollupIncludesChildren": "alkategóriákkal együtt",
    "pivotEmpty": "Nincs könyvelés ebben az időszakban.",
    "rollupAccountColumn": "Számla",
    "rollupOwnColumn": "Saját egyenleg",
    "rollupRolledUpColumn": "Összesített",
    "rollupOtherRow": "Egyéb",
    "rollupEmpty": "Nincs számla ebben az osztályban.",
    "netWorthChart": {
      "title": "Nettó vagyon az időben",
      "summary": "Nettó vagyon {from}-tól ({fromValue}) {to}-ig ({toValue})",
      "resolutionDaily": "Naponta egy pont",
      "resolution": "{days} naponként egy pont",
      "showTable": "Megjelenítés táblázatban",
      "tableCaption": "Nettó vagyon dátum szerint",
      "tableDate": "Dátum",
      "tableValue": "Nettó vagyon",
      "emptyTitle": "Még nincs nettó vagyon",
      "emptyBody": "A nettó vagyon akkor jelenik meg, ha a főkönyvben már vannak tételek.",
      "noMatchTitle": "Nincs tétel ebben az időszakban",
      "noMatchBody": "Válasszon korábbi kezdődátumot, vagy törölje a mezőt a teljes előzmények megtekintéséhez.",
      "invalidRange": "A kezdődátumnak a dátum előtt vagy azzal egyezően kell lennie."
    },
    "overview": {
      "subtitle": "Pénzügyeinek részletes elemzése.",
      "headlines": "Főbb mutatók"
    },
    "tabs": {
      "overview": "Áttekintés",
      "incomeExpenses": "Bevétel és kiadás",
      "accounts": "Számlák",
      "categories": "Kategóriák",
      "payees": "Partnerek",
      "tags": "Címkék",
      "trends": "Trendek",
      "childSummary": "Gyermekek összesítése",
      "lentTo": "Kölcsönadott"
    },
    "lentTo": {
      "subtitle": "Kapcsolatok és más főkönyvek, akiknek pénzt kölcsönadott.",
      "title": "Kölcsönadott",
      "name": "Név",
      "owed": "Tartozás",
      "repaid": "Visszafizetve",
      "forgiven": "Elengedve",
      "actions": "Műveletek",
      "forgive": "Elengedés",
      "empty": {
        "title": "Nincs kölcsönadott összeg",
        "body": "Ha van követelés vagy főkönyvek közti kölcsön, az itt jelenik meg."
      },
      "noTransferHere": "Ebben a főkönyvben nincs könyvelési jogosultsága.",
      "noTransferThere": "A másik főkönyvben nincs könyvelési jogosultsága."
    },
    "rangeEarlier": "Korábbi időszak",
    "rangeLater": "Következő időszak",
    "bucketDaily": "Napi",
    "bucketWeekly": "Heti",
    "bucketMonthly": "Havi",
    "bucketYearly": "Éves",
    "invertedRange": "A kezdő dátum nem lehet a záró dátum után.",
    "rangeTooLong": "Ez az időszak túl hosszú bármely bontásban. Szűkítse a dátumokat.",
    "kpi": {
      "income": "Összes bevétel",
      "expenses": "Összes kiadás",
      "net": "Nettó eredmény",
      "savings": "Megtakarítási arány",
      "vsPrevious": "az előző időszakhoz képest"
    },
    "chart": {
      "incomeVsExpenses": "Bevétel és kiadás",
      "income": "Bevétel",
      "expenses": "Kiadás",
      "net": "Nettó",
      "flowsAria": "Bevétel és kiadás időszakonként",
      "netAria": "Nettó időszakonként",
      "empty": "Nincs időszak ebben a tartományban."
    },
    "expensesByCategory": "Kiadások kategóriánként",
    "other": "Egyéb",
    "total": "Összesen",
    "viewAll": "Összes",
    "topPayees": "Top partnerek",
    "topCategories": "Top kategóriák",
    "topTags": "Top címkék",
    "noPayee": "Nincs partner",
    "untagged": "Címke nélkül",
    "unknownAccount": "Ismeretlen számla",
    "severalCategories": "Több kategória",
    "severalAccounts": "Több számla",
    "largest": {
      "title": "Legutóbbi nagy tételek",
      "date": "Dátum",
      "payee": "Partner / leírás",
      "category": "Kategória",
      "account": "Számla",
      "amount": "Összeg",
      "tags": "Címkék",
      "empty": "Ebben a tartományban nem mozgott pénz.",
      "actions": "Műveletek"
    },
    "table": {
      "name": "Név",
      "entries": "Tételek",
      "amount": "Összeg",
      "share": "Részesedés",
      "period": "Időszak"
    },
    "empty": {
      "title": "Ebben a tartományban nincs megjeleníthető adat",
      "body": "Válasszon szélesebb tartományt vagy másik időközt."
    },
    "accounts": {
      "account": "Számla",
      "inflow": "Be",
      "outflow": "Ki",
      "transfersIn": "Átutalás be",
      "transfersOut": "Átutalás ki",
      "net": "Nettó",
      "noAccess": "A számlaegyenlegekhez ennek a szerepkörnek nincs jogosultsága."
    },
    "tags": {
      "note": "Egy tétel minden címkéjénél beszámít, ezért a címkék összege meghaladhatja az összesen sort."
    },
    "trends": {
      "savingsRate": "Megtakarítási arány ebben a tartományban: {rate}",
      "netTitle": "Nettó időszakonként"
    },
    "interval": "Időköz",
    "periodCount": "{count} időszak",
    "categoryCount": "{count} kategória",
    "periodRollupTotalSuffix": "összesen"
  },
  "planning": {
    "title": "Terv",
    "subtitle": "Célok kitűzése és a pénzügyi jövőd tervezése."
  },
  "targets": {
    "title": "Célok",
    "loading": "Célok betöltése",
    "emptyTitle": "Még nincs cél megadva",
    "emptyBody": "Adj hozzá egy célt, hogy nyomon követhesd az előrehaladást.",
    "errorTitle": "A célok nem tölthetők be",
    "errorBody": "Hiba történt a célok betöltése közben.",
    "retry": "Próbáld újra",
    "noLedger": "Ehhez a fiókhoz még nem tartozik könyvelés.",
    "noAccess": "Nincs jogosultságod a könyvelés céljainak kezeléséhez.",
    "targetLine": "Cél",
    "addTarget": "Új cél",
    "actionsLabel": "Műveletek: {name}",
    "nameLabel": "Név",
    "metricLabel": "Mit kövessen",
    "currencyLabel": "Célvaluta",
    "selectCurrency": "Válassz pénznemet",
    "accountLabel": "Számla",
    "noAccount": "Nincs számla kiválasztva",
    "minValueLabel": "Cél minimum",
    "maxValueLabel": "Cél maximum",
    "minValuePercentLabel": "Cél minimum (%)",
    "maxValuePercentLabel": "Cél maximum (%)",
    "goalDateLabel": "Határidő",
    "chooseCurrencyFirst": "Válassz először valutát",
    "currencyRequired": "Válassz pénznemet ehhez a mutatóhoz",
    "invalidBound": "Adj meg egy érvényes számot",
    "createErrorBody": "A cél nem hozható létre.",
    "save": "Létrehozás",
    "saving": "Mentés…",
    "cancel": "Mégse",
    "deleteAction": "Törlés",
    "deleting": "Törlés…",
    "metric": {
      "ACCOUNT_BALANCE": "Számlaegyenleg",
      "NET_WORTH": "Nettó vagyon",
      "MONTHLY_SAVINGS": "Havi megtakarítás",
      "EXPENSE_INCOME_RATIO": "Kiadás/Bevétel arány",
      "LIABILITY_ASSET_RATIO": "Adósság/Eszköz arány"
    },
    "status": {
      "MET": "Teljesítve",
      "NOT_MET_IN_PROGRESS": "Folyamatban",
      "NOT_MET_MISSED": "Elmulasztva",
      "NO_DATA": "Nincs még adat",
      "NO_ACCOUNT": "Nincs kiválasztott számla"
    },
    "targetDate": "Céldátum",
    "accountOnLine": "Számla"
  },
  "prepaidRecognitions": {
    "sectionLabel": "Elhatárolási ütemterv",
    "title": "Elhatárolás időben",
    "loading": "Ütemterv betöltése",
    "errorTitle": "Ezt az ütemtervet nem sikerült betölteni",
    "retry": "Újra",
    "totalAmount": "Összesen",
    "recognizedAmount": "Elszámolva",
    "pendingAmount": "Folyamatban",
    "cancelledAmount": "Törölve",
    "status": {
      "PENDING": "Folyamatban",
      "RECOGNIZED": "Elszámolva",
      "CANCELLED": "Törölve"
    },
    "viewEntry": "Tétel megtekintése",
    "explanation": "Oszd el ezt a kifizetést több időszakra ahelyett, hogy egyetlen kiadásként számolnád el a fizetés hónapjában. Minden időszak a saját szeletét a saját dátumán számolja el.",
    "expenseAccountLabel": "Elszámolás ide",
    "selectExpenseAccount": "Válassz számlát",
    "spreadLabel": "Elosztás időszakokra",
    "singlePaymentHint": "Egyetlen kifizetésként kerül elszámolásra az alábbi dátumon.",
    "periodsLabel": "Időszakok száma",
    "startDateLabel": "Első elszámolás dátuma",
    "consequence": "Ez minden időszakra egy valódi könyvelési tételt ütemez: minden elszámolási dátum átmozgatja a saját szeletét ebből a kifizetésből a fenti számlára. Semmi nem könyvelődik a saját dátuma előtt.",
    "pendingRetry": "Az előző kísérlet még feldolgozás alatt - próbáld újra egy pillanat múlva.",
    "scheduleAction": "Elhatárolás ütemezése",
    "scheduling": "Ütemezés folyamatban",
    "extension": {
      "label": "Előre fizetett költség",
      "chooseExpense": "Válaszd ki, melyik számlára számolódjon el",
      "invalidPeriods": "Adj meg egész számú időszakot"
    }
  },
  "garage": {
    "title": "Garázs",
    "subtitle": "Autók és járműesemények",
    "addCar": "Autó hozzáadása",
    "loading": "Autók betöltése",
    "emptyTitle": "Nincsenek autók",
    "emptyBody": "Adja hozzá az első autóját",
    "errorTitle": "Az autók nem tölthetők be",
    "detailErrorTitle": "Ez az autó nem tölthető be",
    "errorBody": "Hiba történt az autó betöltése közben. Próbálja újra.",
    "retry": "Próbálja újra",
    "noLedger": "Még nem érhető el főkönyv a fiókjához.",
    "noAccess": "Nincs jogosultsága ennek a főkönyvnek a garázsához.",
    "primary": "Elsődleges",
    "selector": {
      "label": "Autók"
    },
    "moreActions": "További műveletek",
    "tabsLabel": "Autó szakaszai",
    "setPrimary": "Elsődleges autónak jelöl",
    "setPrimaryError": "Az elsődleges autó nem módosítható. Próbálja újra.",
    "status": {
      "ACTIVE": "Aktív",
      "SOLD": "Eladva"
    },
    "form": {
      "nameLabel": "Megnevezés",
      "namePlaceholder": "pl. A szürke",
      "make": "Gyártó",
      "makePlaceholder": "pl. Toyota",
      "model": "Modell",
      "modelPlaceholder": "pl. Corolla",
      "year": "Évjárat",
      "yearPlaceholder": "pl. 2020",
      "color": "Szín",
      "colorPlaceholder": "pl. Szürke",
      "licensePlate": "Rendszám",
      "licensePlatePlaceholder": "pl. ABC-123",
      "vin": "VIN/alvázszám",
      "vinPlaceholder": "17 karakteres VIN",
      "fuelTypeLabel": "Üzemanyag típusa",
      "selectFuelType": "Válasszon...",
      "initialMileage": "Kezdeti km-állás",
      "initialMileagePlaceholder": "0",
      "purchaseDate": "Vásárlás dátuma",
      "notes": "Megjegyzések",
      "notesPlaceholder": "Egyéb megjegyzések...",
      "makePrimary": "Legyen ez az elsődleges autó",
      "cancel": "Mégse",
      "create": "Létrehozás",
      "save": "Mentés",
      "saving": "Mentés...",
      "invalidAmount": "Adjon meg érvényes számot",
      "createErrorBody": "Hiba történt az autó létrehozása közben. Próbálja újra.",
      "updateErrorBody": "Hiba történt az autó mentése közben. Próbálja újra."
    },
    "fuelType": {
      "DIESEL": "Dízel",
      "PETROL": "Benzin",
      "ELECTRIC": "Elektromos",
      "HYBRID": "Hibrid",
      "GAS": "Gáz"
    },
    "edit": "Szerkesztés",
    "delete": "Törlés",
    "deleteCarTitle": "{name} törlése?",
    "deleteCarBody": "Ez a művelet visszafordíthatatlan. A(z) {name} autóhoz tartozó összes esemény, kötvény és ütemterv is törlésre kerül.",
    "deleteCarConfirm": "Törlés",
    "deleteCarError": "Az autót nem sikerült törölni. Próbálja újra.",
    "cancel": "Mégse",
    "stats": {
      "title": "Statisztikák",
      "currentMileage": "Jelenlegi km-állás",
      "totalSpend": "Összes költség",
      "spendInYear": "{year}. évi költség",
      "costPerKm": "Költség/km",
      "costPerKmUnknown": "Nincs megtett táv",
      "odometerConflict": "Ellentmondó km-állás",
      "breakdownTitle": "Bontás számlánként",
      "noStatistics": "Még nincs statisztika",
      "eventCounts": "Eseményszám",
      "periodLabel": "Statisztika időszaka",
      "previousPeriod": "Előző év",
      "nextPeriod": "Következő év",
      "vsLastYear": "előző évhez"
    },
    "details": {
      "title": "Részletek",
      "licensePlate": "Rendszám",
      "vin": "VIN/alvázszám",
      "fuelType": "Üzemanyag típusa",
      "color": "Szín",
      "purchaseDate": "Vásárlás dátuma",
      "initialMileage": "Kezdeti km-állás",
      "notes": "Megjegyzések"
    },
    "events": {
      "title": "Események",
      "empty": "Nincs esemény",
      "logEvent": "Esemény rögzítése",
      "sellCar": "Autó eladása",
      "alreadySold": "Ez az autó már el van adva.",
      "cannotAddToSold": "Eladott autóhoz nem adható esemény. Csak az eladási esemény engedélyezett.",
      "typeTitle": "Esemény típusa",
      "linkedEntry": "Könyvelési tétel",
      "edit": "Szerkesztés",
      "delete": "Törlés",
      "deleteTitle": "Esemény törlése",
      "deleteBody": "Biztosan törli ezt az eseményt?",
      "recordErrorBody": "Hiba történt az esemény rögzítése közben. Próbálja újra.",
      "recentTitle": "Legutóbbi események",
      "columns": {
        "date": "Dátum",
        "type": "Típus",
        "description": "Leírás",
        "odometer": "Km-állás",
        "amount": "Összeg",
        "account": "Számla",
        "notes": "Megjegyzés"
      }
    },
    "eventType": {
      "FUEL": "Tankolás",
      "REPAIR": "Szerviz/Javítás",
      "INSURANCE_PAYMENT": "Biztosítás díj",
      "TAX": "Adó/Illeték",
      "INSPECTION": "Műszaki vizsga",
      "REGISTRATION": "Forgalmi engedély",
      "CAR_WASH": "Mosatás",
      "PARKING": "Parkolás",
      "FINE": "Bírság",
      "MILEAGE_LOG": "Km-állás rögzítés",
      "SELL": "Eladás",
      "BUY": "Vásárlás (autó)",
      "TIRE_CHANGE": "Gumicsere"
    },
    "eventField": {
      "date": "Dátum",
      "mileage": "Km-állás",
      "notes": "Megjegyzések",
      "fuelAmount": "Tankolás mennyisége (liter)",
      "fuelStation": "Töltőállomás",
      "fuelTypeOverride": "Üzemanyag típusa",
      "fuelTypeDefault": "Az autó üzemanyagtípusát használja ({fuelType})",
      "fuelTypeOverrideToggle": "Felülbírálás",
      "fuelTypeUseDefault": "Az autó üzemanyagtípusának használata",
      "selectDefault": "Alapértelmezett",
      "repairShop": "Szerviz neve",
      "description": "Leírás",
      "items": "Elvégzett munkák",
      "itemsHint": "Vesszővel elválasztva",
      "fulfilledScheduleIds": "Teljesített ütemtervek",
      "policyId": "Kötvényszám",
      "selectPolicy": "Válasszon kötvényt...",
      "installmentNumber": "Részlet sorszáma",
      "taxType": "Adó típusa",
      "taxPeriod": "Adó időszak",
      "authority": "Hatóság",
      "referenceNumber": "Hivatkozási szám",
      "station": "Vizsgálóállomás",
      "result": "Eredmény",
      "validUntil": "Lejárat dátuma",
      "expiryDate": "Érvényes",
      "washType": "Mosás típusa",
      "location": "Helyszín",
      "durationMinutes": "Időtartam (perc)",
      "fineType": "Bírság típusa",
      "status": "Állapot",
      "dueDate": "Fizetési határidő",
      "buyerNotes": "Vevőre vonatkozó megjegyzések",
      "sellerNotes": "Eladóra vonatkozó megjegyzések",
      "axle": "Tengely",
      "tireType": "Gumiabroncs típusa",
      "brand": "Márka",
      "shop": "Szerviz / Gumiszerelő"
    },
    "inspectionResult": {
      "PASS": "Megfelelt",
      "FAIL": "Nem felelt meg",
      "CONDITIONAL": "Feltételes"
    },
    "washType": {
      "SELF_SERVICE": "Önkiszolgáló",
      "AUTOMATIC": "Automata mosó",
      "HAND_WASH": "Kézi mosás",
      "DETAILING": "Részletes tisztítás"
    },
    "fineType": {
      "SPEEDING": "Gyorshajtás",
      "PARKING": "Parkolási bírság",
      "OTHER": "Egyéb"
    },
    "fineStatus": {
      "UNPAID": "Kifizetetlen",
      "PAID": "Kifizetve",
      "CONTESTED": "Vitatott"
    },
    "taxType": {
      "WEIGHT_TAX": "Súlyadó",
      "ROAD_TOLL": "Útdíj",
      "OTHER": "Egyéb"
    },
    "tireType": {
      "SUMMER": "Nyári",
      "WINTER": "Téli",
      "ALL_SEASON": "Négy évszakos"
    },
    "axle": {
      "FRONT": "Első tengely",
      "REAR": "Hátsó tengely",
      "ALL": "Mind a négy kerék"
    },
    "journal": {
      "title": "Könyvelési tétel",
      "none": "Nincs könyvelés",
      "unchanged": "Változatlan",
      "create": "Új könyvelési tétel",
      "link": "Meglévő tétel csatolása",
      "expenseAccount": "Kiadási számla",
      "selectExpenseAccount": "Válasszon számlát",
      "incomeAccount": "Bevételi számla",
      "selectIncomeAccount": "Válasszon számlát",
      "sourceAccount": "Forrás számla",
      "selectSourceAccount": "Válasszon számlát",
      "amount": "Összeg",
      "payee": "Kedvezményezett",
      "payeePlaceholder": "pl. MOL",
      "entryLabel": "Könyvelési tétel",
      "selectEntry": "Válasszon tételt...",
      "noEntryFound": "Nem található könyvelési tétel",
      "fineRequiresJournal": "Ennek a bírságnak költsége van. Kérjük, kifizetve jelöléskor csatoljon vagy hozzon létre könyvelési tételt."
    },
    "policies": {
      "title": "Biztosítások",
      "add": "Kötvény hozzáadása",
      "empty": "Nincsenek kötvények",
      "insurer": "Biztosító",
      "insurerPlaceholder": "pl. Generali",
      "policyNumber": "Kötvényszám",
      "policyNumberPlaceholder": "pl. GEN-12345678",
      "type": "Típus",
      "selectType": "Válasszon...",
      "coverageStart": "Érvényesség kezdete",
      "coverageEnd": "Érvényesség vége",
      "paymentSchedule": "Fizetési ütemezés",
      "selectPaymentSchedule": "Válasszon...",
      "notes": "Megjegyzések",
      "notesPlaceholder": "Egyéb megjegyzések...",
      "cancel": "Mégse",
      "create": "Létrehozás",
      "delete": "Törlés",
      "createErrorBody": "Hiba történt a kötvény létrehozása közben. Próbálja újra."
    },
    "policyType": {
      "THIRD_PARTY": "Kötelező (KGFB)",
      "CASCO": "Casco",
      "COMPREHENSIVE": "Casco (teljes körű)",
      "OTHER": "Egyéb"
    },
    "paymentSchedule": {
      "ANNUAL": "Éves",
      "SEMI_ANNUAL": "Féléves",
      "QUARTERLY": "Negyedéves",
      "MONTHLY": "Havi"
    },
    "schedules": {
      "title": "Ütemtervek",
      "add": "Ütemterv hozzáadása",
      "empty": "Nincsenek ütemtervek",
      "nameLabel": "Megnevezés",
      "namePlaceholder": "pl. Olajcsere",
      "intervalCaption": "Intervallum",
      "intervalHint": "Legalább egy intervallumot meg kell adni",
      "intervalKm": "Km-intervallum",
      "intervalKmPlaceholder": "pl. 10000",
      "intervalMonths": "Időintervallum (hónap)",
      "intervalMonthsPlaceholder": "pl. 12",
      "intervalRequired": "Intervallum szükséges",
      "lastDone": "Utoljára",
      "never": "Soha",
      "cancel": "Mégse",
      "create": "Létrehozás",
      "delete": "Törlés",
      "markDone": "Elvégzettnek jelölés",
      "markDoneTitle": "Elvégzettnek jelölés",
      "markDoneBody": "Adja meg az elvégzés adatait",
      "doneDate": "Elvégzés dátuma",
      "doneMileage": "Km-állás",
      "doneMileagePlaceholder": "pl. 85000",
      "createErrorBody": "Hiba történt az ütemterv létrehozása közben. Próbálja újra.",
      "markDoneErrorBody": "Hiba történt az ütemterv elvégzettnek jelölése közben. Próbálja újra."
    },
    "tabOverview": "Áttekintés",
    "extension": {
      "label": "Autós esemény",
      "noCar": "Előbb vedd fel az autót a Garázsban.",
      "loadingCars": "Autók betöltése…",
      "chooseCar": "Válaszd ki az autót",
      "chooseType": "Válaszd ki az esemény típusát",
      "car": "Autó",
      "type": "Esemény típusa",
      "finePaid": "Fizetettként rögzül, mert ez a tétel maga a befizetés.",
      "ownRow": "Az autós költséget tedd külön sorba - az autós esemény egyelőre nem osztozhat más kiadással egy tételen."
    },
    "categories": {
      "maintenance": "Karbantartás",
      "refuelling": "Tankolás",
      "parking": "Parkolás",
      "carWash": "Mosatás",
      "insurance": "Biztosítás",
      "other": "Egyéb"
    },
    "photo": {
      "title": "Fotó",
      "acceptHint": "JPEG, PNG vagy WebP, legfeljebb 5 MB",
      "browse": "Fotó kiválasztása",
      "dropHint": "vagy húzza ide a fotót",
      "removeFile": "Kiválasztott fotó eltávolítása",
      "invalidFileType": "Csak JPEG, PNG vagy WebP fotó választható.",
      "upload": "Fotó feltöltése",
      "uploading": "Feltöltés…",
      "remove": "Fotó törlése",
      "removing": "Törlés…",
      "removeError": "A fotót nem sikerült törölni.",
      "errors": {
        "size": "A fotónak 1 bájt és 5 MB közötti méretűnek kell lennie.",
        "generic": "A fotót nem sikerült menteni. Próbáld újra.",
        "type": "Csak JPEG, PNG vagy WebP fotó tárolható."
      },
      "replace": "Fotó cseréje"
    }
  },
  "receiptScan": {
    "title": "Blokk beolvasása",
    "description": "Tölts fel egy blokkfotót, hogy könyvelési tételt készíthess belőle.",
    "noLedger": "A fiókodhoz egyelőre nem tartozik főkönyv.",
    "noAccess": "Nincs jogosultságod ehhez a főkönyvhöz blokkot beolvasni.",
    "receiptImage": "Blokk fotója",
    "browseFile": "Fotó kiválasztása",
    "dropHint": "vagy húzza ide",
    "acceptHint": "JPEG, PNG, WebP vagy GIF",
    "removeFile": "Fotó eltávolítása",
    "invalidFileType": "Ez a fájl nem támogatott képformátum. Válasszon JPEG, PNG, WebP vagy GIF fotót.",
    "paymentSource": "Fizetési forrás",
    "scanReceipt": "Blokk beolvasása",
    "uploading": "Feltöltés…",
    "previewAlt": "A feltöltött blokk fotója",
    "loading": "Blokk beolvasások betöltése",
    "errorTitle": "A blokk beolvasásokat nem sikerült betölteni",
    "scanErrorTitle": "Ezt a blokk beolvasást nem sikerült betölteni",
    "errorBody": "Hiba történt a blokk beolvasások olvasása közben. Próbáld újra.",
    "retry": "Újra",
    "emptyTitle": "Még nincs beolvasott blokk",
    "emptyBody": "Tölts fel egy blokkfotót, hogy könyvelési tételt készíthess belőle.",
    "tableRegion": "Blokk beolvasások",
    "uploaded": "Feltöltve",
    "payee": "Kedvezményezett",
    "total": "Összesen",
    "actions": "Műveletek",
    "unknownMerchant": "Ismeretlen kereskedő",
    "continue": "Folytatás",
    "view": "Megtekintés",
    "status": {
      "label": "Állapot",
      "MANUAL": "Kézi rögzítés",
      "PENDING": "Feldolgozás…",
      "READY": "Ellenőrzésre kész",
      "NEEDS_REVIEW": "Ellenőrzés szükséges",
      "FAILED": "Sikertelen",
      "COMMITTED": "Könyvelve"
    },
    "analysing": "Blokk elemzése…",
    "date": "Dátum",
    "statedTotal": "Blokkon szereplő összeg",
    "lineCategory": "Kategória",
    "boughtBy": "Ki vette",
    "boughtByYou": "Te",
    "owedByContact": "Ezzel tartozik neked",
    "itemName": "Tétel",
    "amount": "Összeg",
    "quantity": "Mennyiség",
    "rowActions": "Sor műveletei",
    "removeItem": "Tétel törlése",
    "addItem": "Tétel hozzáadása",
    "payeePlaceholder": "pl. Lidl",
    "mismatchWarning": "A tételek összege még nem egyezik a blokkon szereplő végösszeggel. Javítsd az összegeket a könyvelés előtt.",
    "confirmCreate": "Bejegyzés létrehozása",
    "committing": "Létrehozás…",
    "startOver": "Vissza a blokk beolvasásokhoz",
    "needsReviewNotice": "Az automatikus feldolgozás több próbálkozás után sem tudta összeegyeztetni a tételeket a végösszeggel. Ellenőrizd a tételeket alább, vagy próbáld újra beolvasni.",
    "rescan": "Újra beolvasás",
    "rescanning": "Újra beolvasás…",
    "committedNotice": "Ez a blokk már könyvelve lett.",
    "cannotDelete": "Egy sikeresen beolvasott blokk soha nem törölhető.",
    "enterManually": "Ez a beolvasás sikertelen volt, ezért törölhető a blokk beolvasások listájából, vagy add meg alább kézzel az adatokat, és úgy könyveld el.",
    "viewEntryAndReverse": "Nézd meg a bejegyzést, és onnan sztornózd, ha javítani szeretnéd.",
    "delete": "Törlés",
    "deleteConfirmAction": "Igen, törlöm",
    "deleteCancel": "Mégse",
    "failure": {
      "AI_UNAVAILABLE": "Az automatikus blokkolvasás most nem elérhető. Próbáld újra beolvasni, vagy add meg alább kézzel az adatokat.",
      "EXTRACTION_FAILED": "A blokkot nem sikerült automatikusan beolvasni. Próbáld újra beolvasni, vagy add meg alább kézzel az adatokat.",
      "UNKNOWN": "A beolvasás sikertelen volt. Próbáld újra beolvasni, vagy add meg alább kézzel az adatokat."
    }
  },
  "imports": {
    "title": "CSV importálás",
    "description": "Töltsd fel a bankszámlakivonatot, rendeld hozzá az oszlopokat, nézd át, mi jönne létre, majd véglegesítsd.",
    "noLedger": "Jelenleg nem érhető el könyvelés a fiókodhoz.",
    "noAccess": "Nincs jogosultságod tranzakciókat importálni ebbe a könyvelésbe.",
    "backToJobs": "Vissza az importokhoz",
    "upload": {
      "file": "CSV fájl",
      "browseFile": "Fájl kiválasztása",
      "dropHint": "vagy húzza ide",
      "acceptHint": "CSV fájlok",
      "removeFile": "Fájl eltávolítása",
      "invalidFileType": "Ez a fájl nem CSV. Válasszon .csv fájlt.",
      "statementAccount": "Számla",
      "selectStatementAccount": "Válassz számlát",
      "createJob": "Feltöltés és előnézet",
      "creating": "Feltöltés…"
    },
    "mapping": {
      "title": "Oszlopok leképezése",
      "description": "Mondd meg, melyik oszlop milyen adatot tartalmaz a fájlodban. Egy rossz találgatás itt javítható, újrakezdés nélkül.",
      "none": "(nincs)",
      "placeholders": {
        "selectColumn": "Válassz oszlopot…"
      },
      "fields": {
        "date": "Dátum",
        "amount": "Összeg",
        "description": "Megnevezés",
        "accountCode": "Számla kód",
        "externalReference": "Külső azonosító"
      }
    },
    "status": {
      "OPEN": "Nyitott",
      "COMMITTED": "Véglegesítve",
      "ABANDONED": "Elvetve"
    },
    "list": {
      "loading": "Importok betöltése",
      "errorTitle": "Az importok nem tölthetők be",
      "errorBody": "Hiba történt az importok olvasása közben. Próbáld újra.",
      "retry": "Próbáld újra",
      "emptyTitle": "Még nincs import",
      "emptyBody": "Tölts fel egy CSV fájlt, hogy tranzakciókat hozz be ebbe a könyvelésbe.",
      "tableRegion": "Import feladatok",
      "uploaded": "Feltöltve",
      "file": "Fájl",
      "statusLabel": "Állapot",
      "actions": "Műveletek",
      "continue": "Folytatás",
      "view": "Megtekintés"
    },
    "detail": {
      "loading": "Az import betöltése",
      "errorTitle": "Az import nem tölthető be",
      "errorBody": "Hiba történt az import olvasása közben. Próbáld újra.",
      "abandon": "Elvetés",
      "committedNotice": "Ez az import már könyvelve lett.",
      "commit": "Import véglegesítése",
      "committing": "Véglegesítés…"
    },
    "preview": {
      "notice": "Ez egy előnézet. Semmi sem jön létre a véglegesítésig.",
      "totalRows": "Sorok összesen",
      "invalidRows": "Érvénytelen sorok",
      "duplicateRows": "Lehetséges duplikátumok",
      "toCommit": "Létrehozásra kerül",
      "rowNumber": "{number}. sor",
      "date": "Dátum",
      "description": "Megnevezés",
      "amount": "Összeg",
      "counterAccount": "Ellenszámla",
      "excluded": "Kizárva",
      "selectAccount": "Válassz számlát",
      "searchAccounts": "Számlák keresése",
      "noAccountsFound": "Nincs találat",
      "duplicate": "Lehetséges duplikátum",
      "viewMatch": "Egyezés megtekintése"
    }
  },
  "forecast": {
    "title": "Előrejelzés",
    "loading": "Előrejelzés betöltése",
    "emptyTitle": "Még nincs forgatókönyv",
    "emptyBody": "Hozz létre egy forgatókönyvet, hogy lásd, merre tart a nettó vagyonod.",
    "errorTitle": "A forgatókönyvek betöltése nem sikerült",
    "errorBody": "Hiba történt az előrejelzés betöltése közben.",
    "detailErrorTitle": "A forgatókönyv betöltése nem sikerült",
    "projectionErrorTitle": "Az előrejelzést nem sikerült betölteni",
    "retry": "Próbáld újra",
    "noLedger": "Még nem érhető el könyvelés a fiókodhoz.",
    "noAccess": "Nincs jogosultságod ennek a könyvelésnek az előrejelzéséhez.",
    "addScenario": "Forgatókönyv hozzáadása",
    "nameLabel": "Név",
    "createErrorBody": "A forgatókönyv létrehozása nem sikerült.",
    "save": "Létrehozás",
    "saving": "Mentés…",
    "cancel": "Mégse",
    "deleteAction": "Törlés",
    "actionsLabel": "Műveletek: {name}",
    "deleting": "Törlés…",
    "projectionTitle": "Előrejelzés",
    "horizonLabel": "Időtáv",
    "monthsAhead": "{count} hónap",
    "horizonCaption": "{count} hónapos előrejelzés",
    "displayCurrency": "Megjelenítési pénznem",
    "flatProjectionNote": "Ehhez a forgatókönyvhöz még nincs változó vagy esemény, ezért az előrejelzés egyenes vonal a mai nettó vagyonon.",
    "projectionChartLabel": "Nettó vagyon {fromValue}-tól ({from}) {toValue}-ig ({to})",
    "checkAgainstTarget": "Ellenőrzés cél alapján",
    "chooseTarget": "Válassz célt",
    "targetReachedBy": "A cél várhatóan teljesül eddig: {date}",
    "targetNotReached": "A cél ebben az időtávban várhatóan nem teljesül",
    "variablesTitle": "Változók",
    "addVariable": "Változó hozzáadása",
    "noVariables": "Még nincs változó.",
    "monthlyAmountLabel": "Havi összeg",
    "amountLabel": "Összeg",
    "amountPlaceholder": "pl. -800 vagy 500",
    "currencyLabel": "Pénznem",
    "selectCurrency": "Válassz pénznemet",
    "currencyRequired": "Válassz pénznemet",
    "invalidAmount": "Adj meg egy érvényes összeget",
    "startDateLabel": "Kezdete",
    "endDateLabel": "Vége",
    "endDateHint": "Hagyd üresen a záró dátumot, ha a változó az előrejelzés végéig fusson.",
    "dateLabel": "Dátum",
    "variableErrorBody": "A változó hozzáadása nem sikerült.",
    "variablePeriodOpen": "{start}-tól, folyamatos",
    "variablePeriodClosed": "{start} – {end}",
    "eventsTitle": "Események",
    "addEvent": "Esemény hozzáadása",
    "noEvents": "Még nincs esemény.",
    "eventErrorBody": "Az esemény hozzáadása nem sikerült."
  },
  "identityAdmin": {
    "title": "Fiókadminisztráció",
    "noAccess": "Nincs jogosultságod munkamenetek kezelésére vagy fiókok felfüggesztésére.",
    "subjectLabel": "Fiók (subject)",
    "subjectPlaceholder": "Pontos subject, kis- és nagybetű számít",
    "lookUp": "Keresés",
    "subjectHelp": "A munkamenetek és a felfüggesztés a pontosan megadott subject-re vonatkoznak - nincs kereshető listája.",
    "ownAccountNote": "Ez a saját fiókod.",
    "sessionsTitle": "Aktív munkamenetek",
    "sessionsEmpty": "Nincsenek aktív munkamenetek.",
    "sessionsLoading": "Munkamenetek betöltése",
    "sessionsErrorTitle": "A munkamenetek nem tölthetők be",
    "sessionsErrorBody": "Hiba történt a munkamenetek betöltése közben. Próbáld újra.",
    "retry": "Újra",
    "endSession": "Munkamenet lezárása",
    "endingSession": "Lezárás…",
    "endSessionNote": "A munkamenet lezárása azonnal hatályba lép, a munkamenet következő kérésekor. A saját aktuális munkameneted lezárása kijelentkeztet.",
    "endSessionError": "Nem sikerült lezárni ezt a munkamenetet. Próbáld újra.",
    "device": "Eszköz",
    "unknownDevice": "Ismeretlen eszköz",
    "createdAt": "Kezdete",
    "expiresAt": "Lejár",
    "statusTitle": "Fiók állapota",
    "statusUnknown": "Ismeretlen, amíg fel nem függeszted vagy vissza nem állítod a fiókot.",
    "statusActive": "Aktív",
    "statusSuspended": "Felfüggesztve",
    "suspendAction": "Fiók felfüggesztése",
    "suspendConfirmTitle": "Felfüggeszted ezt a fiókot: {subject}?",
    "suspendConfirmBody": "Nem fog tudni bejelentkezni, és minden aktív munkamenete azonnal megszűnik. A fiók bármikor visszaállítható.",
    "suspendConfirmAction": "Fiók felfüggesztése",
    "suspendCancel": "Mégse",
    "suspendError": "Nem sikerült felfüggeszteni ezt a fiókot. Próbáld újra.",
    "suspending": "Felfüggesztés…",
    "restoreAction": "Fiók visszaállítása",
    "restoreError": "Nem sikerült visszaállítani ezt a fiókot. Próbáld újra.",
    "restoring": "Visszaállítás…",
    "cannotSuspendSelf": "A saját fiókodat nem tudod felfüggeszteni."
  },
  "reconciliation": {
    "list": {
      "title": "Egyeztetések",
      "start": "Új egyeztetés",
      "resume": "Egyeztetés folytatása",
      "noLedger": "Jelenleg nem érhető el könyvviteli könyv a fiókjához.",
      "noAccess": "Nincs jogosultsága megtekinteni ennek a könyvviteli könyvnek az egyeztetéseit.",
      "loading": "Egyeztetések betöltése…",
      "errorTitle": "Az egyeztetéseket nem sikerült betölteni",
      "errorBody": "Hiba történt az egyeztetések olvasása közben. Próbáld újra.",
      "retry": "Újra",
      "emptyTitle": "Még nincsenek egyeztetések",
      "emptyBody": "Indítson egy egyeztetést a számlaegyenlegek ellenőrzéséhez.",
      "loadMore": "Továbbiak betöltése"
    },
    "history": {
      "date": "Dátum",
      "status": "Állapot",
      "checked": "Ellenőrizve",
      "corrected": "Javítva",
      "transfers": "Átvezetések",
      "finished": "Lezárva",
      "open": "Folyamatban",
      "view": "Megtekintés"
    },
    "editor": {
      "title": "Egyeztetés",
      "dateLabel": "Tényleges egyenlegek ekkor",
      "progress": "{entered} / {total} számla ellenőrizve",
      "saving": "Mentés…",
      "saved": "Mentve",
      "errorTitle": "Ezt az egyeztetést nem sikerült betölteni",
      "assets": "Eszközök",
      "liabilities": "Kötelezettségek (tartozás összege)",
      "hiddenAccounts": "Rejtett számlák ({count})",
      "actualBalanceFor": "Tényleges egyenleg, {name}",
      "matches": "egyezik",
      "notChecked": "nincs ellenőrizve",
      "confirm": "Megerősítés",
      "correction": "Javítás",
      "gainLoss": "Nyereség/veszteség",
      "balanceChanged": "Ennek a számlának a számított egyenlege megváltozott - ellenőrizze lezárás előtt.",
      "proposalTitle": "Amit a lezárás könyvelni fog",
      "transferHint": "átvezetés: a pénz elmozdult, de sosem lett rögzítve",
      "applyReallocations": "Egyező párok könyvelése átvezetésként",
      "nothingToPost": "Egyezés vagy javítás esetén sincs mit könyvelni.",
      "summaryLine": "{matched} számla egyezik · {notChecked} nincs ellenőrizve (ezekhez nem készül bejegyzés)",
      "discard": "Elvetés",
      "discardConfirm": "Elveti a {count} rögzített egyenleget?",
      "discardConfirmAction": "Egyeztetés elvetése",
      "cancel": "Mégse",
      "finish": "Egyeztetés lezárása",
      "finishing": "Lezárás…",
      "retryFinish": "Egy vagy több egyenleg megváltozott - ellenőrizze a táblázatot, majd nyomja meg újra a Lezárás gombot."
    },
    "detail": {
      "account": "Számla",
      "computedThen": "Akkor számított",
      "actual": "Tényleges",
      "outcome": "Eredmény",
      "finishedBy": "Lezárta: {who}, {when}",
      "outcomeMatched": "egyezik",
      "outcomeCorrected": "javítva",
      "outcomeTransferred": "átvezetve ezzel: {name}",
      "outcomeReversed": "visszavonva",
      "viewEntry": "Bejegyzés megtekintése"
    }
  },
  "notifications": {
    "title": "Értesítések",
    "badgeLabel": "{count} olvasatlan értesítés",
    "emptyTitle": "Még nincs értesítés",
    "emptyBody": "Itt fognak megjelenni a fiókoddal és az exportokkal kapcsolatos értesítések.",
    "errorBody": "Hiba történt az értesítések betöltése közben. Próbáld újra.",
    "errorTitle": "Az értesítéseket nem sikerült betölteni",
    "retry": "Próbáld újra",
    "markRead": "Megjelölés olvasottként",
    "loadMore": "Továbbiak betöltése",
    "loadingMore": "Betöltés…"
  },
  "notificationPreferences": {
    "title": "Értesítési beállítások",
    "subtitle": "Válaszd ki, mely értesítések érjenek el, és milyen csatornán.",
    "typeColumn": "Értesítés",
    "channel": {
      "IN_APP": "Alkalmazásban",
      "EMAIL": "Email"
    },
    "mandatory": "Mindig bekapcsolva",
    "customized": "Egyéni beállítás",
    "showAmounts": "Összegek megjelenítése itt: {channel}",
    "toggleLabel": "{type} - {channel}",
    "errorLoading": "Hiba történt az értesítési beállítások betöltése közben.",
    "errorTitle": "Az értesítési beállításokat nem sikerült betölteni",
    "errorGeneric": "Hiba történt az értesítési beállítások mentése közben. Próbáld újra.",
    "errorTypeMandatory": "Ez az értesítés nem kapcsolható ki.",
    "errorChannelNotSupported": "Ez az értesítés nem érhető el ezen a csatornán.",
    "type": {
      "ACCOUNT_SUSPENDED": "A fiókod felfüggesztve",
      "ACCOUNT_RESTORED": "A fiókod visszaállítva",
      "EXPORT_READY": "Az exportálás elkészült",
      "EXPORT_FAILED": "Az exportálás sikertelen",
      "RECEIPT_SCAN_READY": "A blokk beolvasása elkészült",
      "RECEIPT_SCAN_NEEDS_REVIEW": "A blokk beolvasása ellenőrzést igényel",
      "RECEIPT_SCAN_FAILED": "A blokk beolvasása sikertelen",
      "LEDGER_INVITED": "Meghívó egy főkönyvbe",
      "LEDGER_MEMBER_JOINED": "Új tag csatlakozott",
      "LEDGER_ROLE_CHANGED": "A szereped megváltozott",
      "LEDGER_MEMBER_REMOVED": "Eltávolítva egy főkönyvből",
      "LEDGER_DISABLED": "A főkönyv letiltva",
      "SIGN_IN_NEW_DEVICE": "Bejelentkezés új eszközről",
      "SESSION_ENDED_BY_ADMIN": "A munkamenetet egy rendszergazda lezárta",
      "TRANSFER_PROPOSED": "Átutalás javasolva",
      "TRANSFER_RESOLVED": "Az átutalást elfogadták vagy elutasították",
      "RELATIONSHIP_PROPOSED": "Kapcsolat javasolva"
    }
  },
  "backupRestore": {
    "title": "Biztonsági mentés és visszaállítás",
    "noLedger": "Még nincs elérhető főkönyv a fiókodhoz.",
    "exportTitle": "Főkönyv biztonsági mentése",
    "exportBody": "A biztonsági mentés a teljes főkönyvet tartalmazza - minden számlát, tételt és könyvelési sort, valamint a hiteleket, kapcsolatokat, célokat, a garázst, az előre fizetett ütemterveket és az előrejelzéseket -, így később egy új főkönyvbe visszaállítható.",
    "emptyTitle": "Még nincs biztonsági mentés",
    "emptyBody": "Kérj biztonsági mentést, hogy később visszaállítható fájlként letölthesd.",
    "restoreTitle": "Biztonsági mentés visszaállítása",
    "restoreBody": "A visszaállítás egy vadonatúj, üres főkönyvet hoz létre, és abba tölti be a mentési fájlt. Meglévő főkönyv adatai soha nem íródnak felül.",
    "ledgerName": "Új főkönyv neve",
    "ledgerNamePlaceholder": "pl. Visszaállított háztartás",
    "fileLabel": "Mentési fájl",
    "fileAcceptHint": "JSON mentési fájl",
    "fileBrowse": "Tallózás",
    "fileDropHint": "vagy húzd ide",
    "fileRemove": "Fájl eltávolítása",
    "fileInvalidType": "Ez a fájl nem JSON mentési fájl.",
    "restore": "Mentés visszaállítása",
    "restoring": "Visszaállítás…",
    "restoreError": "A mentés nem állítható vissza. Ellenőrizd a fájlt, és próbáld újra.",
    "restoreSuccess": "{accounts} számla és {entries} tétel került visszaállításra az új főkönyvbe.",
    "openRestoredLedger": "Visszaállított főkönyv megnyitása"
  },
  "ledgerLifecycle": {
    "title": "Főkönyv állapota",
    "noLedger": "Nincs kiválasztott háztartás.",
    "statusActive": "Aktív",
    "statusDisabled": "Letiltva",
    "activeBody": "A háztartás letiltása azonnal kizárja az összes tagot. Az adatai változatlanul megmaradnak, és ezt az oldalt használva bármikor visszaállíthatja.",
    "disabledBody": "Ez a háztartás le van tiltva: senki nem olvashatja vagy módosíthatja az adatait, és a tagok nem tudják megnyitni. Visszaállítás után pontosan olyan lesz, mint korábban.",
    "disableAction": "Háztartás letiltása",
    "disableConfirmTitle": "Letiltja ezt: {name}?",
    "disableConfirmBody": "Minden tag azonnal elveszíti a hozzáférést. Semmi nem törlődik, és ezt az oldalon a háztartás visszaállításával bármikor visszavonhatja.",
    "disableConfirmAction": "Háztartás letiltása",
    "disabling": "Letiltás…",
    "disableCancel": "Marad aktív",
    "disableError": "A háztartást nem sikerült letiltani. Próbálja újra.",
    "restoreAction": "Háztartás visszaállítása",
    "restoring": "Visszaállítás…",
    "restoreError": "A háztartást nem sikerült visszaállítani. Próbálja újra."
  },
  "accountDetail": {
    "balance": "Egyenleg",
    "backToAccounts": "Vissza a számlákhoz",
    "loading": "Számla betöltése",
    "errorTitle": "A számla nem tölthető be",
    "errorBody": "Hiba történt a számla olvasása közben. Próbálja újra.",
    "retry": "Újrapróbálás",
    "path": "Útvonal",
    "ownCurrency": "Saját pénznem",
    "viewInTransactions": "Megnyitás a tranzakciókban",
    "period": {
      "label": "Időszak",
      "month": "Ez a hónap",
      "quarter": "Utolsó 3 hónap",
      "year": "Ez az év",
      "all": "Összes idő"
    },
    "cards": {
      "entries": "Bejegyzések",
      "moneyIn": "Bevétel",
      "moneyOut": "Kiadások",
      "transfers": "Átutalások",
      "transfersIn": "be",
      "transfersOut": "ki",
      "adjustments": "Korrekciók",
      "net": "Nettó",
      "income": "Bevétel",
      "spending": "Kiadás"
    },
    "byPeriodTitle": "Nettó áramlás időszakonként",
    "entriesTitle": "Bejegyzések",
    "entriesCountOne": "1 bejegyzés",
    "entriesCount": "{count} bejegyzés",
    "emptyTitle": "Nincs bejegyzés ebben az időszakban",
    "emptyBody": "Az ebben az időszakban erre a számlára könyvelt bejegyzések itt jelennek meg.",
    "entriesErrorTitle": "A bejegyzések nem tölthetők be",
    "entriesErrorBody": "Hiba történt a számla bejegyzéseinek olvasása közben. Próbálja újra.",
    "loadMore": "Több betöltése",
    "loadingMore": "Betöltés…",
    "endOfList": "Ez az összes bejegyzés ebben az időszakban.",
    "counterAccount": "Ellenoldal",
    "counterMore": "+{count} további",
    "internalMovement": "{from} → {to}",
    "internalNote": "Pénzt mozgat az alszámlák között; a csoport összege nem változik",
    "internalNoteExchange": "Pénzt mozgat az alszámlák között; a csoport összege csak a látott árfolyamkülönbözettel változik",
    "internalBetween": "{count} alszámla között",
    "exchangeDifference": "Árfolyamkülönbség",
    "currencyNote": "Összegek: {currency}",
    "subAccounts": {
      "totalsNote": "Az összegek ezeket az alszámlákat is tartalmazzák",
      "ownEntriesNote": "Ez a lista csak erre a számlára közvetlenül könyvelt tételeket mutatja, az alszámlákra könyvelteket nem.",
      "postableNote": "Könyvelhet erre a számlára is, és az alszámlákra is."
    },
    "subtree": {
      "direct": "Közvetlenül erre a számlára",
      "inSubAccounts": "Alszámlákon",
      "directSegment": "Közvetlenül: {name}",
      "spending": "Kiadásbontás",
      "bySubAccount": "Bontás alszámlánként"
    }
  },
  "forgiveness": {
    "title": "Elengedi ezt az egyenleget?",
    "consequence": "Ez leírja, amivel {name} tartozik. Nem vonható vissza.",
    "currency": "Pénznem",
    "amount": "Elengedendő összeg",
    "amountRequired": "Adjon meg egy elengedendő összeget.",
    "amountTooLarge": "Nem engedhető el több, mint a tartozás.",
    "accountLabel": "Leírás helye",
    "error": "Az egyenleget nem sikerült elengedni.",
    "confirm": "Elengedés",
    "cancel": "Mégse"
  }
}
